var data = [{
    id: 1,
    label: '首页',
    icon: 'mdi-home-outline ',
    path: '/',
    pid: 0,
    is_menu: true,
    children: [{
        id: 1001,
        label: '流程中心',
        path: '/Flow',
        pid: 1,
        children: [{
            id: 1010,
            label: '启动流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowMasterList',
            pid: 1001,
            children: []
          },
          {
            id: 1011,
            label: '待办流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessSteps',
            pid: 1001,
            children: []
          },
          {
            id: 1012,
            label: '草稿',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsDraft',
            pid: 1001,
            children: []
          },
          {
            id: 1013,
            label: '我发起的流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsSelf',
            pid: 1001,
            children: []
          },
          {
            id: 1014,
            label: '我经办的流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsHandled',
            pid: 1001,
            children: []
          },
        ]
      },
      {
        id: 1002,
        label: '内部邮件',
        path: '/mail/list',
        pid: 1,
      },
      {
        id: 1003,
        label: '通讯录',
        path: '/personnel/addressList',
        pid: 1,
      },
    ]
  },
  {
    id: 28,
    label: '工作台',
    icon: 'mdi-eslint',
    path: '/staging',
    pid: 0,
    is_menu: true,
    children: [{
        id: 28001,
        label: '流程中心',
        path: '/Flow',
        pid: 28,
        children: [{
            id: 2800101,
            label: '启动流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowMasterList',
            pid: 28001,
            children: []
          },
          {
            id: 2800102,
            label: '待办流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessSteps',
            pid: 28001,
            children: []
          },
          {
            id: 2800103,
            label: '草稿',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsDraft',
            pid: 28001,
            children: []
          },
          {
            id: 2800104,
            label: '我发起的流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsSelf',
            pid: 28001,
            children: []
          },
          {
            id: 2800105,
            label: '我经办的流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsHandled',
            pid: 28001,
            children: []
          },
        ]
      },
      {
        id: 28002,
        label: '内部邮件',
        path: '/mail/list',
        pid: 28,
      },
      {
        id: 28003,
        label: '通信录',
        path: '/personnel/addressList',
        pid: 28,
      },
    ]
  },
  {
    id: 18,
    label: '驾驶舱',
    icon: 'mdi-home-outline ',
    path: '/cockpit',
    pid: 0,
    is_menu: true,
    children: [{
        id: 18001,
        label: '缴费总览',
        icon: 'mdi-eslint ',
        path: '/cockpit/PaymentStatistics',
        pid: 18,
        is_menu: true,
      },
      {
        id: 18002,
        label: '账龄分析',
        icon: 'mdi-eslint ',
        path: '/cockpit/AgingStatistics',
        pid: 18,
      },
      {
        id: 18015,
        label: '收缴通报',
        icon: 'mdi-eslint ',
        path: '/cockpit/planRate',
        pid: 18,
      },
      {
        id: 18014,
        label: '龙虎榜',
        icon: 'mdi-eslint ',
        path: '/cockpit/historyCollection',
        pid: 18,
      },
      {
        id: 18011,
        label: '历年收缴',
        icon: 'mdi-eslint ',
        path: '/cockpit/historyRate',
        pid: 18,
      },
      {
        id: 18012,
        label: '坏账拨备',
        icon: 'mdi-eslint ',
        path: '/cockpit/badDebt',
        pid: 18,
        children: [{
            id: 18012001,
            label: '坏账拨备设置',
            path: '/cockpit/badDebtSetting',
            pid: 18012,
          },
          {
            id: 18012002,
            label: '坏账拨备',
            path: '/cockpit/badDebt',
            pid: 18012,
          },
          {
            id: 18012003,
            label: '实际拨备',
            icon: 'mdi-eslint ',
            path: '/cockpit/actualDebt',
            pid: 18012,
          },
        ]
      },
      {
        id: 18010,
        label: '催缴统计',
        icon: 'mdi-eslint ',
        path: '/Butler/LegalStatisticsView',
        pid: 18,
      },
      {
        id: 18016,
        label: '智慧停车',
        icon: 'mdi-eslint ',
        path: '/cockpit/parking',
        pid: 18,
      },
      {
        id: 18003,
        label: '能耗管理',
        icon: 'mdi-eslint ',
        // path: '/cockpit/EnergyConsumptionStatistics',
        // path: '/stat/chart',
        path: '/stat/publicShareMeter',
        pid: 18,
      },
      {
        id: 'cockpit-pda',
        label: '到家巡检',
        path: '/cockpit/pda',
        pid: 18,
        children: [{
            id: 'cockpit-pda-primary-overview',
            label: '主营概况',
            path: '/cockpit/pda',
            pid: 'cockpit-pda',
          },
          {
            id: 'cockpit-pda-third-overview',
            label: '非主营概况',
            path: '/quality-pda/third-overview',
            pid: 'cockpit-pda',
          }
        ]
      },
      {
        id: 18005,
        label: '舆情管理',
        icon: 'mdi-eslint ',
        path: '/cockpit/conversation',
        pid: 18,
      },
      {
        id: 18006,
        label: '报事报修',
        icon: 'mdi-eslint ',
        path: '/cockpit/ReportRepairStatistics',
        pid: 18,
        children: [{
            id: 18006001,
            label: '物业端',
            icon: 'mdi-eslint ',
            path: '/cockpit/ReportRepairStatistics',
            pid: 18006,
          },
          {
            id: 18006002,
            label: '业主端',
            icon: 'mdi-eslint ',
            path: '/cockpit/ReportRepairOwnerStatistics',
            pid: 18006,
          },
          {
            id: 18006003,
            label: '品控中心',
            icon: 'mdi-eslint ',
            path: '/cockpit/Group400Statistics',
            pid: 18006,
          },
        ]
      },
      {
        id: 18007,
        label: '投诉建议',
        icon: 'mdi-eslint ',
        path: '/cockpit/ComplaintSuggestionsStatistics',
        pid: 18,
      },
      {
        id: 18008,
        label: '业主拜访',
        icon: 'mdi-eslint ',
        path: '/cockpit/VisitStatistics',
        pid: 18,
      },
      {
        id: 18009,
        label: '满意度调查',
        icon: 'mdi-eslint ',
        path: '/cockpit/SatisfactionStatistics',
        pid: 18,
      },
      // {
      //   id: 18010,
      //   label: '优泊到家',
      //   icon: 'mdi-eslint ',
      //   path: '/cockpit?id=',
      //   pid: 18,
      // },
      // {
      //   id: 180011,
      //   label: '能耗管理静态页',
      //   icon: 'mdi-eslint ',
      //   // path: '/cockpit/EnergyConsumptionStatistics',
      //   path: '/stat/chart',
      //   pid: 18,
      // },
    ]
  },
  {
    id: 4,
    label: "财务管理",
    icon: 'mdi-chart-line  ',
    path: '/pindex/Type',
    pid: 0,
    children: [{
        id: 4001,
        label: "费用设置",
        icon: 'mdi-chart-line  ',
        path: '/Finance',
        pid: 4,
        children: [{
            id: 4002001,
            label: '收费项目设置',
            path: '/pindex/Type',
            pid: 4001,
            children: [{
                id: 4002001001,
                label: '新增',
                pid: 4002001,
              },
              {
                id: 4002001002,
                label: '查看',
                pid: 4002001,
              },
              {
                id: 4002001003,
                label: '修改',
                pid: 4002001,
              },
              {
                id: 4002001004,
                label: '删除',
                pid: 4002001,
              },
            ]
          },
          {
            id: 4001001,
            label: '收费标准设置',
            path: '/pindex/Charge',
            pid: 4001,
            children: [{
                id: 4001001001,
                label: '新增',
                pid: 4001001,
              },
              {
                id: 4001001002,
                label: '查看',
                pid: 4001001,
              },
              {
                id: 4001001005,
                label: '修改',
                pid: 4001001,
              },
              {
                id: 4001001006,
                label: '删除',
                pid: 4001001,
              },
            ]
          },
          {
            id: 4001006,
            label: '房间收费设置',
            path: '/pindex/room/RoomSetUp',
            pid: 4001,
            children: [{
                id: 4001006001,
                label: '查询',
                pid: 4001006,
              },
              {
                id: 4001006002,
                label: '批量设置',
                pid: 4001006,
              },
              {
                id: 4001006003,
                label: '修改设置',
                pid: 4001006,
              },
              {
                id: 4001006004,
                label: '全部修改',
                pid: 4001006,
              },
              {
                id: 4001006005,
                label: '删除',
                pid: 4001006,
              },
              {
                id: 4001006006,
                label: '全部删除',
                pid: 4001006,
              },
              {
                id: 4001006007,
                label: '导出未设置标准的房产',
                pid: 4001006,
              },
            ]
          },
          {
            id: 4001013,
            label: '房间收费对象设置',
            path: '/pindex/room/RoomSetUpUser',
            pid: 4001,
            children: []
          },
          {
            id: 4001014,
            label: '分摊费用设置',
            path: '/pindex/share/ShareSetUp',
            pid: 4001,
            children: []
          },
          // {
          //   id: 4001002,
          //   label: '分摊设置',
          //   path: '/pindex/ShareSetup',
          //   pid: 4001,
          //   is_menu: true,
          //   children: []
          // },
          {
            id: 4001007,
            label: '押金类型设置',
            path: '/pindex/OrderDepositType',
            pid: 4001,
            children: []
          },
          // {
          //   id: 4001003,
          //   label: '折扣设置',
          //   path: '/pindex/discounts',
          //   pid: 4001,
          //   children: []
          // },
          {
            id: 4001004,
            label: '税目分类编码',
            path: '/pindex/GoodsTaxCode',
            pid: 4001,
            children: [{
                id: 4001004001,
                label: '新增',
                pid: 4001004,
              },
              {
                id: 4001004002,
                label: '修改',
                pid: 4001004,
              },
              {
                id: 4001004003,
                label: '删除',
                pid: 4001004,
              },
            ]
          },
          {
            id: 4001005,
            label: '区域收费项税率',
            path: '/pindex/AreaTax',
            pid: 4001,
            children: [{
                id: 4001005001,
                label: '保存',
                pid: 4001005,
              },
              {
                id: 4001005002,
                label: '删除',
                pid: 4001005,
              },
            ]
          },
          {
            id: 4001008,
            label: '票据类型设置',
            path: '/pindex/OrderBillType',
            pid: 4001,
            children: []
          },
        ]
      },
      {
        id: 4007,
        label: "仪表管理",
        icon: 'mdi-chart-line  ',
        path: '/meter',
        pid: 4,
        children: [{
            id: 4007001,
            label: '仪表类型',
            path: '/meter/type?type=0',
            pid: 4007
          },
          {
            id: 4007002,
            label: '仪表登记',
            path: '/meter/meter?type=0',
            pid: 4007,
            children: [{
                id: 4007002000,
                label: '查看',
                pid: 4007002,
              },
              {
                id: 4007002001,
                label: '添加',
                pid: 4007002,
              },
              {
                id: 4007002002,
                label: '导入',
                pid: 4007002,
              },
              {
                id: 4007002003,
                label: '删除',
                pid: 4007002,
              },
              {
                id: 4007002004,
                label: '批量修改收费标准',
                pid: 4007002,
              },
              {
                id: 4007002005,
                label: '批量停用',
                pid: 4007002,
              },
              {
                id: 4007002006,
                label: '能耗',
                pid: 4007002,
              },
              {
                id: 4007002007,
                label: '换表',
                pid: 4007002,
              },
              {
                id: 4007002008,
                label: '移表',
                pid: 4007002,
              },
            ]
          },
          {
            id: 4007003,
            label: '仪表抄表',
            path: '/meter/meterNote?type=0',
            pid: 4007,
            children: [{
                id: 4007003000,
                label: '查看',
                pid: 4007003,
              },
              {
                id: 4007003001,
                label: '全部删除',
                pid: 4007003,
              },
              {
                id: 4007003002,
                label: '抄表',
                pid: 4007003,
              },
              {
                id: 4007003003,
                label: '录入',
                pid: 4007003,
              },
              {
                id: 4007003004,
                label: '全部审核',
                pid: 4007003,
              },
              {
                id: 4007003005,
                label: '全部反审核',
                pid: 4007003,
              },
              {
                id: 4007003006,
                label: '能耗分析',
                pid: 4007003,
              },
              {
                id: 4007003007,
                label: '删除',
                pid: 4007003,
              },
              {
                id: 4007003008,
                label: '审核',
                pid: 4007003,
              },
              {
                id: 4007003009,
                label: '反审核',
                pid: 4007003,
              },
              {
                id: 4007003010,
                label: '流程审核',
                pid: 4007003,
              },
              {
                id: 4007003011,
                label: '全部流程审批',
                pid: 4007003,
              },
            ]
          },
          // {
          //   id: 4007010,
          //   label: '仪表合并费项',
          //   path: '/meter/MeterFeeTag?type=0',
          //   pid: 4007
          // },
          {
            id: 4007008,
            label: '抄表计费',
            path: '/meter/MeterOrder?type=0',
            pid: 4007
          },
          {
            id: 4007009,
            label: '分摊模板',
            path: '/meter/ApportionTemplate?type=0',
            pid: 4007
          },
          {
            id: 4007004,
            label: '抄表明细',
            path: '/meter/meterNoteDetail?type=0',
            pid: 4007
          },
          {
            id: 4007005,
            label: '虚拟表登记',
            path: '/meter/share/meter',
            pid: 4007,
            children: [{
                id: 4007005000,
                label: '查看',
                pid: 4007005,
              },
              {
                id: 4007005001,
                label: '新增',
                pid: 4007005,
              },
              {
                id: 4007005002,
                label: '删除',
                pid: 4007005,
              },
              {
                id: 4007005003,
                label: '批量修改',
                pid: 4007005,
              },
              {
                id: 4007005004,
                label: '编辑',
                pid: 4007005,
              },
            ]
          },
          {
            id: 4007006,
            label: '虚拟表计算',
            path: '/meter/share/MeterCalculation',
            pid: 4007,
            children: [{
                id: 4007006000,
                label: '查看',
                pid: 4007006,
              },
              {
                id: 4007006001,
                label: '计算',
                pid: 4007006,
              },
              {
                id: 4007006002,
                label: '修改计费周期',
                pid: 4007006,
              },
              {
                id: 4007006003,
                label: '删除',
                pid: 4007006,
              },
              {
                id: 4007006004,
                label: '全部删除',
                pid: 4007006,
              },
              {
                id: 4007006005,
                label: '查看日记',
                pid: 4007006,
              },
              {
                id: 4007006006,
                label: '审核',
                pid: 4007006,
              },
              {
                id: 4007006007,
                label: '反审核',
                pid: 4007006,
              },
              {
                id: 4007006008,
                label: '全部审核',
                pid: 4007006,
              },
              {
                id: 4007006009,
                label: '全部反审核',
                pid: 4007006,
              },
              {
                id: 4007006010,
                label: '修改',
                pid: 4007006,
              },
            ]
          },
          {
            id: 4007007,
            label: '虚拟表费用查询',
            path: '/meter/share/MeterOrderSelect',
            pid: 4007,
            children: []
          },
        ]
      },
      {
        id: 4002,
        label: "费用核算",
        path: '/pindex/Type',
        pid: 4,
        children: [{
            id: 4004012,
            label: '常规费用管理',
            path: '/pindex/RoutineExpense',
            pid: 4002,
            children: []
          },
          /*{
            id: 4004016,
            label: '仪表费用管理',
            path: '/pindex/MeterExpense',
            pid: 4002,
            children: []
          },
          {
            id: 4004015,
            label: '分摊费用管理',
            path: '/pindex/ShareExpense',
            pid: 4002,
            children: []
          },*/
          /*{
            id: 4004013,
            label: '临时费用管理',
            path: '/pindex/TemporaryExpense',
            pid: 4002,
            children: []
          },*/
          // {
          //   id: 4004006,
          //   label: '生成账单',
          //   path: '/pindex/Allocation',
          //   pid: 4002,
          //   is_menu: true,
          //   children: [{
          //       id: 4004006001,
          //       label: '绑定收费项',
          //       pid: 4004006,
          //     },
          //     {
          //       id: 4004006002,
          //       label: '生成账单',
          //       pid: 4004006,
          //     },
          //     {
          //       id: 4004006003,
          //       label: '修改',
          //       pid: 4004006,
          //     },
          //     {
          //       id: 4004006004,
          //       label: '删除',
          //       pid: 4004006,
          //     },
          //   ]
          // },
          //原项辉写的应收款导入
          // {
          //   id: 4002003,
          //   label: '应收款导入',
          //   path: '/pindex/ReceivablesExcel',
          //   pid: 4002
          // },
          /*{
            id: 4002003,
            label: '应收款导入',
            path: '/pindex/OrderReceivablesExcel',
            pid: 4002
          },*/
          // {
          //   id: 4002004,
          //   label: '已缴款导入',
          //   path: '/pindex/PaidExcel',
          //   pid: 4002
          // },
          /*{
            id: 4003003,
            label: '已缴款导入',
            path: '/order/discountExcel',
            pid: 4002,
            children: [{
              id: 4003003001,
              label: '审核',
              pid: 4003003,
            }, ]
          },*/
          // {
          //   id: 4003003,
          //   label: '批量折扣/减免',
          //   path: '/order/discountExcel',
          //   pid: 4002,
          //   children: [{
          //     id: 4003003001,
          //     label: '审核',
          //     pid: 4003003,
          //   }, ]
          // },
          {
            id: 4004014,
            label: '应收款审核',
            path: '/pindex/MoneyCheck',
            pid: 4002
          },
          // {
          //   id: 4004005,
          //   label: '导入费用',
          //   path: '/pindex/Allocations',
          //   pid: 4002,
          //   children: [{
          //       id: 4004005001,
          //       label: '设置费用',
          //       pid: 4004005,
          //     },
          //     {
          //       id: 4004005002,
          //       label: '导入费用',
          //       pid: 4004005,
          //     },
          //     {
          //       id: 4004005003,
          //       label: '模板',
          //       pid: 4004005,
          //     },
          //     {
          //       id: 4004005004,
          //       label: '下载',
          //       pid: 4004005,
          //     },
          //     {
          //       id: 4004005005,
          //       label: '生成账单',
          //       pid: 4004005,
          //     },
          //     {
          //       id: 4004005006,
          //       label: '删除',
          //       pid: 4004005,
          //     },
          //   ]
          // },
          // {
          //   id: 4002002,
          //   label: '分摊费用',
          //   path: '/pindex/Share',
          //   pid: 4002,
          //   is_menu: true,
          //   children: [{
          //       id: 4002002001,
          //       label: '添加分摊',
          //       pid: 4002002,
          //     },
          //     {
          //       id: 4002002002,
          //       label: '审核',
          //       pid: 4002002,
          //     },
          //     {
          //       id: 4002002003,
          //       label: '拒绝',
          //       pid: 4002002,
          //     }
          //   ]
          // },
          // {
          //   id: 4002010,
          //   label: '分摊导入',
          //   path: '/pindex/ShareEnter',
          //   pid: 4002,
          //   children: [{
          //       id: 4002010001,
          //       label: '分摊导入',
          //       pid: 4002010,
          //     },
          //     {
          //       id: 4002010004,
          //       label: '分摊模板下载',
          //       pid: 4002010,
          //     },
          //     {
          //       id: 4002010002,
          //       label: '审核',
          //       pid: 4002010,
          //     },
          //     {
          //       id: 4002010003,
          //       label: '拒绝',
          //       pid: 4002010,
          //     }
          //   ]
          // },
          // {
          //   id: 4003009,
          //   label: '清除缴费',
          //   path: '/order/clearOrder',
          //   pid: 4002,
          //   children: []
          // },
          // {
          //   id: 4003004,
          //   label: '财务报表',
          //   path: '/order/financeReport',
          //   pid: 4002,
          //   is_menu: true,
          //   children: []
          // },
          {
            id: 4002012,
            label: '应收款查询',
            path: '/order/chargeQuery',
            pid: 4002,
            children: []
          },
          {
            id: 4002011,
            label: '应收款调整',
            path: '/order/chargeModify',
            pid: 4002,
            children: []
          },
          {
            id: 4002005,
            label: '应收款拆分',
            path: '/pindex/ReceivablesSplit',
            pid: 4002,
            children: []
          },
          {
            id: 4002006,
            label: '应收缴合并',
            path: '/pindex/ReceivablesMerge',
            pid: 4002,
            children: []
          },
          {
            id: 4003006,
            label: '月结',
            path: '/order/monthClosing',
            pid: 4002,
            children: []
          },
        ]
      },
      {
        id: 4003,
        label: "费用收付",
        path: '/order/list',
        pid: 4,
        children: [{
            id: 4003007,
            label: '应收费用',
            path: '/order/order',
            pid: 4003,
            children: [{
                id: 4003007004,
                label: '查看详情',
                pid: 4003007,
              },
              {
                id: 4003007002,
                label: '费用收付',
                pid: 4003007,
              },
              {
                id: 4003007008,
                label: '账单冻结',
                pid: 4003007,
              },
              {
                id: 4003007010,
                label: '同步业户/冻结账单',
                pid: 4003007,
              },
              {
                id: 4003007005,
                label: '减免',
                pid: 4003007,
              },
              {
                id: 4003007006,
                label: '核销选择',
                pid: 4003007,
              },
              {
                id: 4003007007,
                label: '红冲',
                pid: 4003007,
              },
              {
                id: 4003007009,
                label: '冲销',
                pid: 4003007,
              },
              {
                id: 4003007011,
                label: '费用收付修改缴款时间',
                pid: 4003007,
              },
              {
                id: 4003007012,
                label: '审核(当前房产)',
                pid: 4003007,
              },
              {
                id: 4003007013,
                label: '全部审核(当前项目)',
                pid: 4003007,
              },
              {
                id: 4003007014,
                label: '新增账单',
                pid: 4003007,
              },
            ]
          },
          {
            id: 4003002,
            label: '缴费订单',
            path: '/order/listDate',
            pid: 4003,
            children: [{
                id: 4003002001,
                label: '筛选组织搜索功能',
                pid: 4003002,
              },
              {
                id: 4003002002,
                label: '添加备注',
                pid: 4003002,
              },
              {
                id: 4003002003,
                label: '查账',
                pid: 4003002,
              },
              {
                id: 4003002004,
                label: '查看详情',
                pid: 4003002,
              },
              {
                id: 4003002005,
                label: '退款/冲销',
                pid: 4003002,
              },
              {
                id: 4003002006,
                label: '导出',
                pid: 4003002,
              },
            ]
          },
          {
            id: 4003008,
            label: '临时费用',
            path: '/order/temporary',
            pid: 4003,
            children: []
          },
          {
            id: 4003013,
            label: '银行托收',
            path: '/order/bankDeduction',
            pid: 4003
          },
          {
            id: 4003014,
            label: '银行托收设置',
            path: '/order/bankDeductionSetting',
            pid: 4003
          },
          {
            id: 4003015,
            label: '账单托收',
            path: '/order/billCollection',
            pid: 4003
          },
          {
            id: 4003012,
            label: '押金管理',
            path: '/order/deposit',
            pid: 4003,
            children: [{
                id: 4003012001,
                label: '收取押金',
                pid: 4003012,
              },
              {
                id: 4003012002,
                label: '修改收取日期权限',
                pid: 4003012,
              },
              {
                id: 4003012003,
                label: '作废',
                pid: 4003012,
              },
            ]
          },
          {
            id: 4003010,
            label: '预收款管理',
            path: '/order/advance',
            pid: 4003,
            children: [{
                id: 4003010001,
                label: '预收款存取',
                pid: 4003010,
              },
              {
                id: 4003010002,
                label: '修改收取日期权限',
                pid: 4003010,
              },
              {
                id: 4003010003,
                label: '冲销',
                pid: 4003010,
              },
              {
                id: 4003010004,
                label: '作废',
                pid: 4003010,
              },
            ]
          },
          {
            id: 4003011,
            label: '预收款结转',
            path: '/order/advanceCarry',
            pid: 4003,
            children: []
          },
          {
            id: 4003016,
            label : '销账',
            path : '/order/disAmountOrder',
            pid : 4003,
            children : [],
          }
          // {label: "应收费用缴款",children: []},
          // {label: "应收款补缴",children: []},
          // {label: "临时缴款",children: []},
          // {label: "预收款管理",children: []},
          // {label: "押金管理",children: []},
          // {label: "预收款自动结转",children: []},
          // {label: "银行托收",children: []},
          // {label: "收费减免",children: []},
          // {label: "销账",children: []},
        ]
      },
      // {label: "催缴管理",children: [
      //     {label: "催缴管理",children: []},
      //     {label: "发函管理",children: []},
      //     {label: "原因分析",children: []},
      //     {label: "坏账处理",children: []},
      //     {label: "催缴情况明细表",children: []},
      //     {label: "催缴过程明细表",children: []},
      //     {label: "催缴阶段汇总表",children: []},
      //     {label: "拒缴原因汇总表",children: []},
      //     {label: "催缴结果汇总表",children: []},
      //     {label: "欠费分析报表",children: []},
      //     {label: "催费计划跟进表",children: []}
      //   ]},
      {
        id: 4036,
        label: "账单比对",
        path: '/Comparison/Receivable',
        pid: 4,
        children: [{
            id: 40360001,
            label: '应收对账',
            path: '/Comparison/Receivable',
            pid: 4036,
            children: []
          },
          {
            id: 40360002,
            label: '欠费对账',
            path: '/Comparison/Arrearage',
            pid: 4036,
            children: []
          },
          {
            id: 40360003,
            label: '收费对账',
            path: '/Comparison/Charge',
            pid: 4036,
            children: []
          },
          {
            id: 40360004,
            label: '费用对账',
            path: '/Comparison/Money',
            pid: 4036,
            children: [{
                id: 40360004001,
                label: '同步一致(只给项目开同步为欠费)',
                pid: 40360004,
              },
              {
                id: 40360004002,
                label: '同步为欠费',
                pid: 40360004,
              },
              {
                id: 40360004003,
                label: '同步减免',
                pid: 40360004,
              },
            ]
          },
        ]
      },
      {
        id: 4004,
        label: "票据管理",
        path: '/Finance/invoice',
        pid: 4,
        children: [{
            id: 4004001,
            label: '发票管理',
            path: '/Finance/invoice',
            pid: 4004,
            children: [{
                id: 4004001001,
                label: '发票开具',
                pid: 4004001,
              },
              {
                id: 4004001002,
                label: '红冲发票',
                pid: 4004001,
              },
            ]
          },
          {
            id: 4004002,
            label: '税盘管理',
            path: '/Finance/invoiceDisc',
            pid: 4004,
            children: [
              {
                id: 4004002001,
                label: '添加税盘',
                pid: 4004002,
              },
              {
                id: 4004002002,
                label: '修改税盘',
                pid: 4004002,
              },
              {
                id: 4004002003,
                label: '删除税盘',
                pid: 4004002,
              },
              {
                id: 4004002004,
                label: '管理项目',
                pid: 4004002,
              },
              {
                id: 4004002005,
                label: '全电票验证',
                pid: 4004002,
              },
            ]
          },
          // {
          //   id: 40050001,
          //   label: '票据打印列表',
          //   path: '/Finance/bill',
          //   pid: 4004,
          //   is_menu: true,
          //   children: []
          // },
          // {label: "票据购入",children: []},
          // {label: "票据领用",children: []},
          // {label: "票据使用管理",children: []},
          // {label: "票据核销",children: []},
          // {label: "票据补录",children: []},
          // {label: "票据结存汇总表",children: []},
          // {label: "票据核销情况表",children: []},
          // {label: "票据使用月报表",children: []},
          // {label: "票据打印修改月报表",children: []},
          // {label: "票据更换",children: []}
        ]
      },
      {
        id: 4005,
        label: "收银日报",
        path: '/OrderDaily/list',
        pid: 4,
        children: [{
            id: 4005001,
            label: '日报表流程',
            path: '/OrderDaily/flow',
            pid: 4005,
            children: []
          },
          {
            id: 4005002,
            label: '收银日报表',
            path: '/OrderDaily/list',
            pid: 4005,
            children: []
          },
          {
            id: 4005003,
            label: '收银日报审核',
            path: '/OrderDaily/check',
            pid: 4005,
            children: []
          },
        ]
      },
      {
        id: 4006,
        label: "财务报表",
        path: '/Forms/orderList',
        pid: 4,
        children: [

        ]
      },
      {
        id: 4008,
        label: "指标管理",
        path: '/Finance/target',
        pid: 4,
        children: [{
            id: 4008001,
            label: '指标设置',
            path: '/Finance/target',
            pid: 4008,
            children: []
          },
          {
            id: 4008002,
            label: '指标调整',
            path: '/Finance/targetAdjust',
            pid: 4008,
            children: [{
                id: 4008002001,
                label: '删除权限',
                pid: 4008002,
              },
              {
                id: 4008002002,
                label: '添加权限',
                pid: 4008002,
              }
            ]
          },
        ]
      },
      {
        id: 4009,
        label: "公设费管理",
        path: '/Finance/amenityFee',
        pid: 4,
        children: [{
            id: 4009001,
            label: '公设费管理',
            path: '/Finance/amenityFee',
            pid: 4009,
            children: []
          },
          {
            id: 4009002,
            label: '公设费收缴',
            path: '/Finance/amenityCharge',
            pid: 4009,
            children: []
          }
        ]
      },
      {
        id : 4011 ,
        label : '收缴年度计划',
        pid : 4 ,
        path :'/budget/budget-year'
      }
      // {label: "财务接口",children: [
      //     {label: "财务科目导入",children: []},
      //     {label: "收付科目对照设置",children: []},
      //     {label: "接口对照项目设置",children: []},
      //     {label: "银行对照项目设置",children: []},
      //     {label: "用友文件接口格式设置",children: []},
      //     {label: "用友物业财务数据导出",children: []},
      //     {label: "用友NC接口对照配置",children: []},
      //     {label: "银行账户账套设置",children: []}
      //   ]},
      // {label: "财务报表",children: []}
    ]
  },
  {
    id: 3,
    label: "业户管理",
    icon: 'mdi-home-outline ',
    path: '/User/Owner',
    pid: 0,
    children: [
      // {
      //   id: 3001,
      //   label: "业主管理",
      //   icon: 'mdi-home-outline ',
      //   path: '/User/Owner',
      //   pid: 3,
      //   children: [{
      //     id: 3001001,
      //     label: '业主管理',
      //     path: '/User/Owner',
      //     pid: 3001,
      //     is_menu: true,
      //     children: [{
      //         id: 3001001001,
      //         label: '筛选组织搜索功能',
      //         pid: 3001001,
      //       },
      //       {
      //         id: 3001001002,
      //         label: '添加业主',
      //         pid: 3001001,
      //       },
      //       {
      //         id: 3001001003,
      //         label: '修改业主',
      //         pid: 3001001,
      //       },
      //       {
      //         id: 3001001004,
      //         label: '删除业主',
      //         pid: 3001001,
      //       },
      //     ]
      //   }]
      // },
      {
        id: 3002,
        label: '房产管理',
        path: '/pindex/House',
        pid: 3,
        children: [
          /*{
            id: 3002002,
            label: '房产导入',
            path: '/pindex/Import',
            pid: 3002,
          },*/
          {
            id: 3002003,
            label: '房产审核',
            icon: 'mdi-archive-outline ',
            path: '/pindex/Examine',
            pid: 3002,
          },
          // {
          //   id: 3002005,
          //   label: '战区管理',
          //   icon: 'mdi-archive-outline ',
          //   path: '/pindex/zone',
          //   pid: 3002,
          // },
          {
            id: 3002004,
            label: '房产管理',
            path: '/pindex/houseManagement',
            pid: 3002,
            children: [{
                id: 3002004001,
                label: '添加房产',
                pid: 3002004,
              },
              {
                id: 3002004002,
                label: '查询列表',
                pid: 3002004,
              },
              {
                id: 3002004003,
                label: '修改房产',
                pid: 3002004,
              },
              {
                id: 3002004004,
                label: '导入新房产',
                pid: 3002004,
              },
              {
                id: 3002004005,
                label: '导出房产',
                pid: 3002004,
              },
              {
                id: 3002004006,
                label: '删除房产',
                pid: 3002004,
              },
              {
                id: 3002004007,
                label: '添加区域',
                pid: 3002004,
              },
              {
                id: 3002004008,
                label: '添加大楼',
                pid: 3002004,
              },
              {
                id: 3002004009,
                label: '添加单元',
                pid: 3002004,
              },
              {
                id: 3002004010,
                label: '导入修改房产',
                pid: 3002004,
              },
            ]
          },

          // {label: "房产登记",children: []},
          // {label: "小区房产汇总表",children: []},
          // {label: "房产信息明细表",children: []},
          // {label: "房产信息汇总表",children: []},
          // {label: "房产面积变更明细表",children: []},
          // {label: "物业房产项目统计表",children: []},
          // {label: "项目信息",children: []}
        ]
      },
      // {
      //   id: 3003,
      //   label: '区域管理',
      //   path: '/pindex/region',
      //   pid: 3,
      //   is_menu: true,
      //   children: [{
      //       id: 3003001,
      //       label: '添加区域',
      //       pid: 3003,
      //     },
      //     {
      //       id: 3003002,
      //       label: '查看',
      //       pid: 3003,
      //     },
      //     {
      //       id: 3003003,
      //       label: '修改区域',
      //       pid: 3003,
      //     },
      //     {
      //       id: 3003004,
      //       label: '删除区域',
      //       pid: 3003,
      //     },
      //   ]
      // },
      {
        id: 3004,
        label: "业户管理",
        icon: 'mdi-chart-line  ',
        path: '/user/CustomerAdd',
        pid: 3,
        children: [
          // {
          //   id: 3004002,
          //   label: '房产变动',
          //   path: '/User/Owner',
          //   pid: 3001,
          //   is_menu: true,
          //   children:[]
          // },
          {
            id: 3004003,
            label: '售楼登记',
            path: '/User/CustomerSale',
            pid: 3004,
            is_menu: true,
            children: []
          },
          {
            id: 3004004,
            label: '入伙管理',
            path: '/user/CustomerAdd',
            pid: 3004,
            is_menu: true,
            children: []
          },
          {
            id: 3004005,
            label: '入住管理',
            path: '/User/CustomerCheckin',
            pid: 3004,
            is_menu: true,
            children: []
          },


          // {
          //   id: 3004008,
          //   label: '车辆登记',
          //   path: '/User/Owner',
          //   pid: 3001,
          //   is_menu: true,
          //   children:[]
          // },
          // {
          //   id: 3004009,
          //   label: '客户关怀',
          //   path: '/User/Owner',
          //   pid: 3001,
          //   is_menu: true,
          //   children:[]
          // },
          // {
          //   id: 3004010,
          //   label: '客户报表',
          //   path: '/User/Owner',
          //   pid: 3001,
          //   is_menu: true,
          //   children:[]
          // },
          {
            id: 3004009,
            label: '房态统计',
            path: '/HouseCode/HouseStatistics',
            pid: 3004,
            is_menu: true,
            children: []
          },
          {
            id: 3004012,
            label: '房态管理',
            path: '/HouseCode/RoomStatus',
            pid: 3004,
            children: [{
                id: 3004012001,
                label: '导出',
                pid: 3004012,
              },
              {
                id: 3004012002,
                label: '导入',
                pid: 3004012,
              },
              {
                id: 3004012003,
                label: '修改房态',
                pid: 3004012,
              },
              {
                id: 3004012004,
                label: '修改房态确认按钮',
                pid: 3004012,
              },
            ]
          },
          {
            id: 3004001,
            label: '业户信息',
            path: '/Customer',
            pid: 3004,
            is_menu: true,
            children: []
          },
        ]
      },
      {
        id: 3005,
        label: "一户一码",
        icon: 'mdi-chart-line  ',
        path: '/HouseCode',
        pid: 3,
        children: [{
          id: 3005001,
          label: '一户一码',
          path: '/HouseCode/list',
          pid: 3005,
          is_menu: true,
          children: []
        }]
      },
      {
        id: 3006,
        label: "业户报表",
        icon: 'mdi-chart-line  ',
        path: '/Customer/ReportCustomer',
        pid: 3
      },
    ]
  },
  {
    id: 20,
    label: '客户管理',
    icon: 'mdi-home-outline ',
    path: '',
    pid: 0,
    children: [{
        id: 17004,
        label: '业户维护',
        path: '',
        pid: 20,
        children: [{
            id: 8008,
            label: '业主拜访',
            path: '/visit/log',
            pid: 17004,
          },
          {
            id: 17004001,
            label: '业主好友维护',
            path: '/wework/member',
            pid: 17004,
          },
          {
            id: 17004002,
            label: '业主群管理',
            path: '/wework/group',
            pid: 17004,
          },
        ]
      },
      {
        id: 8003,
        label: '舆情会话',
        path: '/Conversation',
        pid: 20,
        children: [{
            id: 8003001,
            label: '会话管理',
            icon: 'mdi-home-outline ',
            path: '/Conversation/Chat',
            pid: 8003,
          },
          {
            id: 8003002,
            label: '关键字管理',
            icon: 'mdi-home-outline ',
            path: '/Conversation/Keyword',
            pid: 8003,
          },
          {
            id: 8003003,
            label: '群管理',
            icon: 'mdi-home-outline ',
            path: '/Conversation/GroupChat',
            pid: 8003,
          },
          {
            id: 8003004,
            label: '社群总览',
            icon: 'mdi-home-outline ',
            path: '/Conversation/Overview',
            pid: 8003,
          },
          {
            id: 8003005,
            label: '项目活跃分析',
            icon: 'mdi-home-outline ',
            path: '/Conversation/ProjectActive',
            pid: 8003,
          },
          {
            id: 8003006,
            label: '项目关注重点',
            icon: 'mdi-home-outline ',
            path: '/Conversation/ProjectFocus',
            pid: 8003,
          },
          {
            id: 8003007,
            label: '项目危机排名',
            icon: 'mdi-home-outline ',
            path: '/Conversation/ProjectCrisis',
            pid: 8003,
          },
          {
            id: 8003008,
            label: '群活跃分析',
            icon: 'mdi-home-outline ',
            path: '/Conversation/GroupActive',
            pid: 8003,
          },
          {
            id: 8003009,
            label: '群关注重点',
            icon: 'mdi-home-outline ',
            path: '/Conversation/GroupFocus',
            pid: 8003,
          },
          {
            id: 8003010,
            label: '群危机排名',
            icon: 'mdi-home-outline ',
            path: '/Conversation/GroupCrisis',
            pid: 8003,
          },
          {
            id: 8003011,
            label: '群成员分析',
            icon: 'mdi-home-outline ',
            path: '/Conversation/MemberAnalyze',
            pid: 8003,
          },
        ],
      },
      {
        id: 8005,
        label: '电子名贴',
        path: '/Card',
        pid: 20,
        children: [{
            id: 8005001,
            label: '会员管理',
            icon: 'mdi-home-outline ',
            path: '/Card/User',
            pid: 8005,
            is_menu: true
          },
          {
            id: 8005002,
            label: '名片管理',
            icon: 'mdi-home-outline ',
            path: '/Card/Card',
            pid: 8005,
            is_menu: true
          },
          {
            id: 8005003,
            label: '内容管理',
            icon: 'mdi-home-outline ',
            path: '/Card/Article',
            pid: 8005,
            is_menu: true
          },
          {
            id: 8005004,
            label: '分组管理',
            icon: 'mdi-home-outline ',
            path: '/Card/UserGroup',
            pid: 8005,
            is_menu: true
          },
          {
            id: 8005005,
            label: '背景管理',
            icon: 'mdi-home-outline ',
            path: '/Card/CardBackground',
            pid: 8005,
            is_menu: true
          },
          {
            id: 8005006,
            label: '主题设置',
            icon: 'mdi-home-outline ',
            path: '/Card/CardStyle',
            pid: 8005,
            is_menu: true
          },
          {
            id: 8005007,
            label: '海报管理',
            icon: 'mdi-home-outline ',
            path: '/Card/CardPoster',
            pid: 8005,
            is_menu: true
          },
          {
            id: 8005008,
            label: '配置管理',
            icon: 'mdi-home-outline ',
            path: '/Card/Config',
            pid: 8005,
            is_menu: true
          },
          {
            id: 8005009,
            label: '行业管理',
            icon: 'mdi-home-outline ',
            path: '/Card/Industry',
            pid: 8005,
            is_menu: true
          },
          {
            id: 8005010,
            label: '部门配置',
            icon: 'mdi-home-outline ',
            path: '/Card/DepartmentConfig',
            pid: 8005,
            is_menu: true
          },
        ],
      },
      {
        id: 80011,
        label: '客户业主信息',
        path: '/client/client_customer',
        pid: 20,
      },
      {
        id: 8009,
        label: '客户分类',
        path: '/client/client_type',
        pid: 20,
      },
      {
        id: 8010,
        label: '客户信息',
        path: '/client/client_list',
        pid: 20,
      },
      {
        id: 8014,
        label: '客户业主活动',
        path: '',
        pid: 20,
        children: [{
            id: 8014001,
            label: '拜访计划',
            path: '/client/visit_plan?leixing=1',
            pid: 8014,
          },
          {
            id: 8014002,
            label: '拜访方案',
            path: '/client/visit_project?leixing=1',
            pid: 8014,
          },
          {
            id: 8014003,
            label: '拜访花絮',
            path: '/client/visit_gags?leixing=1',
            pid: 8014,
          },
          {
            id: 8014004,
            label: '拜访总结',
            path: '/client/visit_report?leixing=1',
            pid: 8014,
          },
        ]
      },
      {
        id: 8015,
        label: '客户业主座谈会',
        path: '',
        pid: 20,
        children: [{
            id: 8015001,
            label: '拜访计划',
            path: '/client/visit_plan?leixing=2',
            pid: 8015,
          },
          {
            id: 8015002,
            label: '拜访方案',
            path: '/client/visit_project?leixing=2',
            pid: 8015,
          },
          {
            id: 8015003,
            label: '拜访花絮',
            path: '/client/visit_gags?leixing=2',
            pid: 8015,
          },
          {
            id: 8015004,
            label: '拜访总结',
            path: '/client/visit_report?leixing=2',
            pid: 8015,
          },
        ]
      },
      {
        id: 8016,
        label: '客户业主接待',
        path: '',
        pid: 20,
        children: [{
            id: 8016001,
            label: '拜访计划',
            path: '/client/visit_plan?leixing=3',
            pid: 8016,
          },
          {
            id: 8016002,
            label: '拜访方案',
            path: '/client/visit_project?leixing=3',
            pid: 8016,
          },
          {
            id: 8016003,
            label: '拜访花絮',
            path: '/client/visit_gags?leixing=3',
            pid: 8016,
          },
          {
            id: 8016004,
            label: '拜访总结',
            path: '/client/visit_report?leixing=3',
            pid: 8016,
          },
        ]
      },
      {
        id: 8017,
        label: '客户业主宴会',
        path: '',
        pid: 20,
        children: [{
            id: 8017001,
            label: '拜访计划',
            path: '/client/visit_plan?leixing=4',
            pid: 8017,
          },
          {
            id: 8017002,
            label: '拜访方案',
            path: '/client/visit_project?leixing=4',
            pid: 8017,
          },
          {
            id: 8017003,
            label: '拜访花絮',
            path: '/client/visit_gags?leixing=4',
            pid: 8017,
          },
          {
            id: 8017004,
            label: '拜访总结',
            path: '/client/visit_report?leixing=4',
            pid: 8017,
          },
        ]
      },
      {
        id: 8018,
        label: '客户业主关怀',
        path: '',
        pid: 20,
        children: [{
            id: 8018001,
            label: '拜访计划',
            path: '/client/visit_plan?leixing=5',
            pid: 8018,
          },
          {
            id: 8018002,
            label: '拜访方案',
            path: '/client/visit_project?leixing=5',
            pid: 8018,
          },
          {
            id: 8018003,
            label: '拜访花絮',
            path: '/client/visit_gags?leixing=5',
            pid: 8018,
          },
          {
            id: 8018004,
            label: '拜访总结',
            path: '/client/visit_report?leixing=5',
            pid: 8018,
          },
        ]
      },

    ]
  },
  {
    id: 8,
    label: '管家服务',
    icon: 'mdi-view-grid',
    path: '',
    pid: 0,
    children: [{
        id: 8001,
        label: '报事报修',
        path: '/Repair',
        pid: 8,
        children: [{
            id: 8001001,
            label: '报事报修',
            icon: 'mdi-home-outline ',
            path: '/Repair/repairs',
            pid: 8001,
            is_menu: true
          },
          {
            id: 8001002,
            label: '暂挂审核',
            icon: 'mdi-home-outline ',
            path: '/Repair/hangUpRepair',
            pid: 8001,
            is_menu: true
          },
          {
            id: 8001003,
            label: '预警设置',
            icon: 'mdi-home-outline ',
            path: '/Repair/rwarning',
            pid: 8001,
            is_menu: true
          },
        ],
      },
      {
        id: 8002,
        label: '投诉建议',
        path: '/Complaint',
        pid: 8,
        children: [{
            id: 8002001,
            label: '投诉建议',
            icon: 'mdi-home-outline ',
            path: '/Complaint/complaints',
            pid: 8002,
            is_menu: true
          },
          {
            id: 8002002,
            label: '暂挂审核',
            icon: 'mdi-home-outline ',
            path: '/Complaint/cpending',
            pid: 8002,
            is_menu: true
          },
          {
            id: 8002003,
            label: '预警设置',
            icon: 'mdi-home-outline ',
            path: '/Complaint/cwarning',
            pid: 8002,
            is_menu: true
          },
        ],
      },
      // {
      //   id: 8004,
      //   label: '咨询管理',
      //   path: '/Consult',
      //   pid: 8,
      //   children: [{
      //       id: 8004001,
      //       label: '咨询管理',
      //       icon: 'mdi-home-outline ',
      //       path: '/Consult/consult',
      //       pid: 8004,
      //       is_menu: true
      //     },
      //     {
      //       id: 8004002,
      //       label: '暂挂审核',
      //       icon: 'mdi-home-outline ',
      //       path: '/Consult/cowarning',
      //       pid: 8004,
      //       is_menu: true
      //     },
      //     {
      //       id: 8004003,
      //       label: '预警设置',
      //       icon: 'mdi-home-outline ',
      //       path: '/Consult/coending',
      //       pid: 8004,
      //       is_menu: true
      //     },
      //   ],
      // },
      {
        id: 8007,
        label: '催缴管理',
        path: '/Butler/Legal',
        pid: 8,
        is_menu: false,
        children: [{
            id: 8007001,
            label: '催费计划',
            path: '/Butler/ExpeditingFeesPlan',
            pid: 8007,
            is_menu: false,
            children: [{
                id: 8007001001,
                label: '计划模板导出',
                pid: 8007001,
              },
              {
                id: 8007001002,
                label: '计划模板导入',
                pid: 8007001,
              },
            ]
          },
          {
            id: 8007002,
            label: '自催管理',
            path: '/Butler/Legal',
            pid: 8007,
            is_menu: true,
            children: []
          },
          {
            id: 8007003,
            label: '诉讼管理',
            pid: 8007,
            is_menu: true,
            children: [
              {
                id: 8007003001,
                label: '项目诉讼',
                path: '/Butler/Litigation',
                pid: 8007003,
                is_menu: true,
                children: []
              },
              {
                id: 8007003002,
                label: '第三方诉讼',
                path: '/Butler/ThirdPartyLitigation',
                pid: 8007003,
                is_menu: true,
                children: []
              },
            ]
          },
          {
            id: 8007004,
            label: '第三方管理',
            path: '/Butler/ThirdPartyLegal',
            pid: 8007,
            is_menu: true,
            children: []
          },
          {
            id: 8007007,
            label: '龙虎榜',
            icon: 'mdi-eslint ',
            path: '/cockpit/planRate',
            pid: 8007,
          },
          {
            id: 8007008,
            label: '收缴通报',
            icon: 'mdi-eslint ',
            path: '/cockpit/historyCollection',
            pid: 8007,
          },
          {
            id: 8007006,
            label: '抽检记录',
            path: '/Butler/TaskCount',
            pid: 8007,
            is_menu: true,
            children: []
          },
          {
            id: 8007009,
            label: '短信催费',
            path: '/Butler/LegalSms',
            pid: 8007,
            is_menu: true,
            children: []
          },
          {
            id: 8007005,
            label: '报表中心',
            path: '/Butler/ReportLegal',
            pid: 8007,
            is_menu: true,
            children: []
          },
        ]
      },
      // {
      //   id: 8013,
      //   label: '诉讼管理',
      //   icon: 'mdi-eslint ',
      //   path: '/Butler/Litigation',
      //   pid: 8,
      //   is_menu: false,
      //   children: [
      //     {
      //       id: 8013001,
      //       label: '诉讼计划',
      //       path: '/Butler/ExpeditingFeesPlan',
      //       pid: 8013,
      //       is_menu: true,
      //       children: []
      //     },
      //     {
      //       id: 8013003,
      //       label: '诉讼统计',
      //       path: '/Butler/LitigationStatistics',
      //       pid: 8013,
      //       is_menu: true,
      //       children: []
      //     },
      //   ]
      // },
      // {
      //   id: 8019,
      //   label: '第三方管理',
      //   path: '/Butler/Legal',
      //   pid: 8,
      //   is_menu: false,
      //   children: [
      //     {
      //       id: 8019001,
      //       label: '第三方计划',
      //       path: '/Butler/ExpeditingFeesPlan',
      //       pid: 8019,
      //       is_menu: true,
      //       children: []
      //     },
      //
      //     {
      //       id: 8019003,
      //       label: '第三方统计',
      //       path: '/Butler/ThirdPartyStatistics',
      //       pid: 8019,
      //       is_menu: true,
      //       children: []
      //     },
      //   ]
      // },
      {
        id: 8011,
        label: '房产认证',
        icon: 'mdi-eslint ',
        path: '/Butler/PropertyCertificationList',
        pid: 8,
        is_menu: false,
        children: [{
            id: 8011001,
            label: '房产认证',
            icon: 'mdi-eslint ',
            path: '/Butler/PropertyCertificationList',
            pid: 8011,
          },
          {
            id: 8011002,
            label: '房产统计',
            icon: 'mdi-eslint ',
            path: '/Butler/PropertyCertificationStatistics',
            pid: 8011,
          },
        ]
      },
      {
        id: 8012,
        label: '项目账号',
        icon: 'mdi-eslint ',
        path: '/Butler/ProjectAccount',
        pid: 8,
        is_menu: true
      },

      // {
      //   id: 11,
      //   label: '智慧办公',
      //   icon: 'mdi-eslint ',
      //   path: '/Oa/CheckWorkAdmin',
      //   pid: 8,
      //   children: [{
      //       id: 11001,
      //       label: '排班管理',
      //       icon: 'mdi-eslint ',
      //       path: '/Oa/CheckWorkAdmin',
      //       pid: 11,
      //       is_menu: true,
      //       children: [{
      //           id: 11001001,
      //           label: '管理员列表',
      //           icon: 'mdi-eslint ',
      //           path: '/Oa/CheckWorkAdmin',
      //           pid: 11001,
      //         },
      //         {
      //           id: 11001002,
      //           label: '员工列表',
      //           icon: 'mdi-eslint ',
      //           path: '/Oa/CheckWorkUser',
      //           pid: 11001,
      //         },
      //         {
      //           id: 11001003,
      //           label: '排班列表',
      //           icon: 'mdi-eslint ',
      //           path: '/Oa/CheckWorkUserClass',
      //           pid: 11001,
      //         },
      //       ]
      //     },
      //     {
      //       id: 11002,
      //       label: '模块设置',
      //       icon: 'mdi-eslint ',
      //       path: '/Oa/OAIndex',
      //       pid: 11,
      //       is_menu: true,
      //       children: [{
      //           id: 11002001,
      //           label: '功能列表',
      //           icon: 'mdi-home-outline ',
      //           path: '/Oa/OAIndex',
      //           pid: 11002,
      //         },
      //         {
      //           id: 11002002,
      //           label: '栏目列表',
      //           icon: 'mdi-home-outline ',
      //           path: '/Oa/AppChannel',
      //           pid: 11002,
      //         },
      //       ]
      //     },
      //     {
      //       id: 11003,
      //       label: '人员管理',
      //       icon: 'mdi-eslint ',
      //       path: '/Oa/UserManage',
      //       pid: 11,
      //       is_menu: true,
      //       children: [{
      //         id: 11003001,
      //         label: '人员管理',
      //         icon: 'mdi-home-outline ',
      //         path: '/Oa/UserManage',
      //         pid: 11003,
      //       }, ]
      //     },
      //   ],
      // },

      // {
      //   id: 3004007,
      //   label: '装修管理',
      //   path: '/User/CustomerFurnish',
      //   pid: 8,
      //   is_menu: true,
      //   children: []
      // },
      {
        id: 3004007,
        label: '装修管理',
        path: '/User/CustomerFurnish',
        pid: 8,
        is_menu: false,
        children: [{
            id: 3004007002,
            label: '数据总览',
            icon: 'mdi-home-outline ',
            path: '/User/FurnishMasterPreview',
            pid: 3004007,
          },{
            id: 3004007001,
            label: '装修列表',
            icon: 'mdi-home-outline ',
            path: '/User/CustomerFurnish',
            pid: 3004007,
          },
        ]
      },
      {
        id: 3004006,
        label: '出租管理',
        path: '/User/CustomerRent',
        pid: 8,
        is_menu: true,
        children: []
      },
      {
        id: 8020,
        label: '短信管理',
        path: '/Butler/Sms',
        pid: 8,
        is_menu: false,
        children: [{
            id: 8020001,
            label: '短信模版',
            icon: 'mdi-home-outline ',
            path: '/Butler/SmsTemplate',
            pid: 8020,
          },
          {
            id: 8020002,
            label: '短信收发',
            icon: 'mdi-home-outline ',
            path: '/Butler/Sms',
            pid: 8020,
          },
          {
            id: 8020003,
            label: '员工短信管理',
            icon: 'mdi-home-outline ',
            path: '/Butler/SmsUser',
            pid: 8020,
          },
          {
            id: 8020004,
            label: '短信敏感词管理',
            icon: 'mdi-home-outline ',
            path: '/Butler/SmsSensitiveWord',
            pid: 8020,
          },
          {
            id: 8020005,
            label: '短信余额提醒',
            icon: 'mdi-home-outline ',
            path: '/Butler/SmsRemain',
            pid: 8020,
          },
        ]
      },
    ]
  },
  {
    id: 13,
    label: '流程管理',
    icon: 'mdi-eslint ',
    path: '/Flow',
    pid: 0,
    children: [{
        id: 13001,
        label: '流程类别',
        icon: 'mdi-eslint ',
        path: '/flow/FlowType',
        pid: 13,
        children: [

        ]
      },
      {
        id: 13004,
        label: '流程管理',
        icon: 'mdi-eslint ',
        path: '/flow/FlowMaster',
        pid: 13,
        children: [

        ]
      },
      {
        id: 13010,
        label: '业务管理',
        icon: 'mdi-eslint ',
        path: '/flow/FlowProfessionalType',
        pid: 13,
        children: [{
            id: 13010001,
            label: '业务类型',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProfessionalType',
            pid: 13010,
            children: [

            ]
          },
          {
            id: 13010002,
            label: '业务管理',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProfessionalWork',
            pid: 13010,
            children: [

            ]
          },
          {
            id: 13010003,
            label: '业务日志',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProfessionalWorkLog',
            pid: 13010,
            children: [

            ]
          },
        ]
      },
      // {
      //   id: 13002,
      //   label: '流程编辑',
      //   icon: 'mdi-eslint ',
      //   path: '/flow/FlowSheet',
      //   pid: 13,
      //   children: [
      //
      //   ]
      // },
      // {
      //   id: 13003,
      //   label: '角色设置',
      //   icon: 'mdi-eslint ',
      //   path: '/flow/UserRole',
      //   pid: 13,
      //   children: [
      //
      //   ]
      // },
      // {
      //   id: 13020,
      //   label: '流程模型管理',
      //   icon: 'mdi-eslint ',
      //   path: '/flow/FlowModelList',
      //   pid: 13,
      //   children: [
      //
      //   ]
      // },
      // {
      //   id: 13005,
      //   label: '流程操作',
      //   icon: 'mdi-eslint ',
      //   path: '/flow/FlowView',
      //   pid: 13,
      //   children: [
      //
      //   ]
      // },
      // {
      //   id: 13006,
      //   label: '流程预览',
      //   icon: 'mdi-eslint ',
      //   path: '/flow/BpmnView',
      //   pid: 13,
      //   children: [
      //
      //   ]
      // },
      // {
      //   id: 13021,
      //   label: '流程表单设计',
      //   icon: 'mdi-eslint ',
      //   path: '/flow/FlowFormDesign',
      //   pid: 13,
      //   children: [
      //
      //   ]
      // },
      // {
      //   id: 13007,
      //   label: 'ER模型',
      //   icon: 'mdi-eslint ',
      //   path: '/flow/ER',
      //   pid: 13,
      //   children: []
      // },
      {
        id: 13008,
        label: '流程中心',
        icon: 'mdi-eslint ',
        path: '/flow/FlowMasterList',
        pid: 13,
        children: []
      },
      {
        id: 13009,
        label: '办理中心',
        icon: 'mdi-eslint ',
        path: '/flow/FlowProcessSteps',
        pid: 13,
        children: []
      },
      {
        id: 13011,
        label: '流程报表',
        icon: 'mdi-eslint ',
        path: '/flow/FlowTimeoutReport',
        pid: 13,
        children: []
      },
      {
        id: 13012,
        label: '流程调度',
        icon: 'mdi-eslint ',
        path: '/flow/FlowAbnormal',
        pid: 13,
        children: [{
          id: 13012001,
          label: '异常流程',
          icon: 'mdi-eslint ',
          path: '/flow/FlowAbnormal',
          pid: 13012,
          children: []
        },{
          id: 13012002,
          label: '流程转移',
          icon: 'mdi-eslint ',
          path: '/flow/FlowDeploy',
          pid: 13012,
          children: []
        }, ]
      },
      {
        id: 13013,
        label: '旧流程查询',
        icon: 'mdi-eslint ',
        path: '/flow/FlowOldHistory',
        pid: 13,
        children: [{
          id: 13013001,
          label: '流程列表',
          icon: 'mdi-eslint ',
          path: '/flow/FlowOldHistory',
          pid: 13013,
          children: []
        }, ]
      },
    ]
  },
  {
    id: 17,
    label: '品质管理',
    icon: 'mdi-home-outline',
    path: '',
    pid: 0,
    is_menu: true,
    children: [{
        id: 17001,
        label: '到家巡检',
        icon: 'mdi-eslint ',
        pid: 17,
        children: [{
            id: 17001001,
            label: '主营巡检概况',
            path: '/cockpit/pda',
            pid: 17001,
          },
          {
            id: 17001014,
            label: '非主营概况',
            path: '/quality-pda/third-overview',
            pid: 17001,
            is_menu: false,
            children: [{
                id: 'quality-pda-third-overview',
                label: '非主营概况',
                pid: 17001014,
                path: '/quality-pda/third-overview',
              },
              {
                id: 'quality-pda-third-user-trail',
                label: '人员轨迹',
                pid: 17001014,
              }
            ]
          },
          {
            id: 17001002,
            label: '地点管理',
            path: '/pda/bluetooth',
            pid: 17001,
          },
          {
            id: 17001003,
            label: '任务管理',
            path: '/pda/equipment',
            pid: 17001,
          },
          {
            id: 17001004,
            label: '任务抽检',
            path: '/pda/check',
            pid: 17001,
          },
          {
            id: 17001005,
            label: '巡检管理',
            path: '/pda/inspection',
            pid: 17001,
          },
          {
            id: 17001006,
            label: '操作日记',
            path: '/pda/diary',
            pid: 17001,
          },
          {
            id: 17001007,
            label: '权限架构',
            path: '/pda/jurisdiction',
            pid: 17001,
          },
          {
            id: 17001008,
            label: '部门管理',
            path: '/pda/department',
            pid: 17001,
          },
          {
            id: 17001009,
            label: '人员管理',
            path: '/pda/user',
            pid: 17001,
          },
          {
            id: 17001010,
            label: '整改工单',
            path: '/pda/repair',
            pid: 17001,
          },
          {
            id: 17001011,
            label: '地图巡航',
            path: '/pda/map',
            pid: 17001,
          },
          {
            id: 17001012,
            label: '工牌设备',
            path: '/pda/deviceIndex',
            pid: 17001,
          },
          {
            id: 17001013,
            label: '工牌管理',
            path: '/pda/deviceUserIndex',
            pid: 17001,
          },
        ],
      },
      {
        id: 17002,
        label: '品质检查',
        path: '',
        pid: 17,
        children: [{
            id: 17002001,
            label: '检查分类',
            path: '/quality-check/category',
            pid: 17002,
            is_menu: false,
            children: [{
                id: 17002001001,
                label: '查询',
                pid: 17002001
              },
              {
                id: 17002001002,
                label: '编辑',
                pid: 17002001
              },
              {
                id: 17002001003,
                label: '删除',
                pid: 17002001
              }
            ]
          },
          {
            id: 17002002,
            label: '检查模板',
            path: '/quality-check/template',
            pid: 17002,
            is_menu: false,
            children: [{
                id: 17002002001,
                label: '查询',
                pid: 17002002
              },
              {
                id: 17002002002,
                label: '新增',
                pid: 17002002
              },
              {
                id: 17002002003,
                label: '编辑',
                pid: 17002002
              },
              {
                id: 17002002004,
                label: '删除',
                pid: 17002002
              },
              {
                id: 17002002005,
                label: '导入',
                pid: 17002002
              }
            ]
          },
          {
            id: 17002003,
            label: '年度计划',
            path: '/quality-check/schedule',
            pid: 17002,
            is_menu: false,
            children: [{
                id: 17002003001,
                label: '查询',
                pid: 17002003
              },
              {
                id: 17002003002,
                label: '新增',
                pid: 17002003
              },
              {
                id: 17002003003,
                label: '查看/编辑',
                pid: 17002003
              },
              {
                id: 17002003004,
                label: '导入',
                pid: 17002003
              },
              {
                id: 17002003005,
                label: '复制',
                pid: 17002003
              },
              {
                id: 17002003006,
                label: '删除',
                pid: 17002003
              },
              {
                id: 17002003007,
                label: '管理',
                pid: 17002003
              },
            ]
          },
          {
            id: 17002006,
            label: '检查报告',
            path: '/quality-check/report',
            pid: 17002,
            is_menu: false,
            children: [{
                id: 17002006001,
                label: '查询',
                pid: 17002006
              },
              {
                id: 17002006002,
                label: '新增',
                pid: 17002006
              },
              {
                id: 17002006003,
                label: '编辑',
                pid: 17002006
              },
              {
                id: 17002006004,
                label: '删除',
                pid: 17002006
              }
            ]
          },
          {
            id: 17002004,
            label: '检查记录',
            path: '/quality-check/record',
            pid: 17002,
            is_menu: false,
            children: [{
                id: 17002004001,
                label: '查询',
                pid: 17002004
              },
              {
                id: 17002004002,
                label: '查看',
                pid: 17002004
              },
              {
                id: 17002004007,
                label: '编辑',
                pid: 17002004
              },
              {
                id: 17002004003,
                label: '生成整改计划',
                pid: 17002004
              },
              {
                id: 17002004004,
                label: '预览',
                pid: 17002004
              },
              {
                id: 17002004005,
                label: '导出',
                pid: 17002004
              },
              {
                id: 17002004006,
                label: '删除',
                pid: 17002004
              }
            ]
          },
          {
            id: 17002007,
            label: '整改记录',
            path: '/quality-check/repair',
            pid: 17002,
            is_menu: false,
            children: [{
                id: 17002007001,
                label: '查询',
                pid: 17002007
              },
              {
                id: 17002007002,
                label: '审核',
                pid: 17002007
              },
              {
                id: 17002007003,
                label: '导出',
                pid: 17002007
              },
              {
                id: 17002007004,
                label: '删除',
                pid: 17002007
              }
            ]
          },
          {
            id: 17002005,
            label: '检查报表',
            path: '/quality-check/reports',
            pid: 17002,
            is_menu: false,
            children: [
              {
                id: 17002005001,
                label: '战区品质检查指标执行情况统计',
                pid: 17002005
              },
              {
                id: 17002005002,
                label: '战区检查得分明细表',
                pid: 17002005
              },
              {
                id: 17002005003,
                label: '战区检查管家主任得分明细表',
                pid: 17002005
              },
              {
                id: 17002005004,
                label: '战区项目品质整改率',
                pid: 17002005
              },
              {
                id: 17002005005,
                label: '战区品质检查计划完成率',
                pid: 17002005
              },
            ]
          },
        ]
      },
      {
        id: 17005,
        label: '客户满意度',
        path: '',
        pid: 17,
        children: [{
          id: 17005001,
          label: '满意度明细',
          path: '/question/question_answer',
          pid: 17005,
        }, {
          id: 17005002,
          label: '参与调查房产',
          path: '/question/question_house',
          pid: 17005,
        }, {
          id: 17005003,
          label: '短信推送记录',
          path: '/question/question_sms',
          pid: 17005,
        }]
      },
      {
        id: 17003,
        label: 'AI监控',
        path: '',
        pid: 17,
        children: [{
          id: 17003001,
          label: '设备管理',
          path: '/camera/device',
          pid: 17003,
        }, ]
      },
      {
        id: 17006,
        label: '400投诉',
        path: '',
        pid: 17,
        children: [{
          id: 17006001,
          label: '话务处理',
          path: '/complaint400/add',
          pid: 17006,
        }, ]
      },
    ],
  },
  {
    id: 19,
    label: '行政管理',
    icon: 'mdi-home-outline ',
    path: '',
    pid: 0,
    is_menu: true,
    children: [
      {
        id: 19001,
        pid: 19,
        label: '企业微信',
        children: [
          {
            id: 19001001,
            pid: 19001,
            label: '内部群管理',
            path: '/user-group/list',
            is_menu: false,
            children: [
              {
                id: 19001001001,
                pid: 19001001,
                label: '列表展示',
              },
              {
                id: 19001001002,
                pid: 19001001,
                label: '编辑',
              }
            ]
          },
          {
            id: 19001002,
            pid: 19001,
            label: '消息推送',
            path: '/user-group/send',
            is_menu: false,
            children: [
              {
                id: 19001002001,
                pid: 19001002,
                label: '消息推送',
              },
              {
                id: 19001002002,
                pid: 19001002,
                label: '所有人',
              }
            ]
          },
          {
            id: 19001003,
            pid: 19001,
            label: '消息管理',
            path: '/user-group/log'
          },
        ]
      }
    ]
  },
  {
    id: 26,
    label: '协同办公',
    icon: '',
    path: '',
    pid: 0,
    is_menu: true,
    children: [{
        id: 26001,
        label: '公共信息',
        icon: 'mdi-eslint ',
        path: '',
        pid: 26,
        children: [{
            id: 26001004,
            label: '通讯录',
            icon: 'mdi-eslint ',
            path: '/personnel/addressList',
            pid: 26001,
          },
          {
            id: 26001001,
            label: '新闻公告',
            icon: 'mdi-eslint ',
            path: '/new/newList',
            pid: 26001,
          },
          {
            id: 26001002,
            label: '我的收文',
            icon: 'mdi-eslint ',
            path: '/notice/receiveList',
            pid: 26001,
          },
          {
            id: 26001003,
            label: '新闻管理',
            icon: 'mdi-eslint ',
            path: '/new/newManageList',
            pid: 26001,
          },
        ]
      },
      {
        id: 26002,
        label: '个人事务',
        icon: 'mdi-eslint ',
        path: '',
        pid: 26,
        children: [{
            id: 26002001,
            label: '内部邮件',
            icon: 'mdi-eslint ',
            path: '/mail/list',
            pid: 26002,
            is_menu: false,
            children: [{
                id: 26002001002,
                label: '邮件列表',
                pid: 26002001,
              },
              {
                id: 26002001001,
                label: '群发所有人',
                pid: 26002001,
              },
              {
                id: 26002001003,
                label: '首页显示其它系统未读数量',
                pid: 26002001,
              }
            ]
          },
          {
            id: 26002002,
            label: '我的发文',
            icon: 'mdi-eslint ',
            path: '/notice/sendList',
            pid: 26002,
          }
        ]
      },
      {
        id: 26003,
        label: '流程中心',
        path: '/Flow',
        pid: 26,
        children: [{
            id: 260031,
            label: '启动流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowMasterList',
            pid: 26003,
            children: []
          },
          {
            id: 260032,
            label: '待办流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessSteps',
            pid: 26003,
            children: []
          },
          {
            id: 260033,
            label: '草稿',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsDraft',
            pid: 26003,
            children: []
          },
          {
            id: 260034,
            label: '我发起的流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsSelf',
            pid: 26003,
            children: []
          },
          {
            id: 260035,
            label: '我经办的流程',
            icon: 'mdi-eslint ',
            path: '/flow/FlowProcessStepsHandled',
            pid: 26003,
            children: []
          },
        ]
      },
    ]
  },
  {
    id: 16,
    label: '人力资源',
    icon: 'mdi-home-outline',
    path: '/Personnel/addressList',
    pid: 0,
    is_menu: true,
    children: [
      // {
      //   id: 16001,
      //   label: '通讯录',
      //   icon: 'mdi-eslint ',
      //   path: '/Personnel/addressList',
      //   pid: 16,
      // },
      {
        id: 10004,
        label: '操作员管理',
        icon: 'mdi-eslint',
        path: '/Config/OperatorSetting',
        pid: 16,
        is_menu: true,
        children: [{
            id: 10004001,
            label: '角色管理',
            pid: 10003,
          },
          {
            id: 10004002,
            label: '房产权限',
            pid: 10003,
          },
          {
            id: 10004003,
            label: '查看员工',
            pid: 10003,
          }
        ]
      },
      {
        id: 10003,
        label: '角色权限设置',
        icon: 'mdi-eslint',
        path: '/Config/RoleSetting',
        pid: 16,
        is_menu: true,
        children: [{
            id: 10003001,
            label: '添加角色',
            pid: 10003,
          },
          {
            id: 10003002,
            label: '编辑角色',
            pid: 10003,
          },
          {
            id: 10003003,
            label: '删除角色',
            pid: 10003,
          },
          {
            id: 10003004,
            label: '查看角色',
            pid: 10003,
          },
        ]
      },
      // {
      //   id: 16004,
      //   label: '新视窗',
      //   icon: 'mdi-eslint',
      //   path: 'https://oa.gdzawy.com:8888/',
      //   pid: 16,
      // },
      {
        id: 16009,
        label: '员工管理',
        path: 'hr-staff',
        pid: 16,
        children: [{
            id: 16009001,
            label: '员工信息',
            path: '/hr-staff/index',
            pid: 16009,
          },
          {
            id: 16009002,
            label: '花名册',
            path: '/hr-staff/roster',
            pid: 16009,
          },
          {
            id: 16009003,
            label: '黑名单管理',
            path: '/hr-staff/black-list',
            pid: 16009,
          },
          {
            id: 16009004,
            label: '薪酬级别管理',
            path: '/hr-staff/level-list',
            pid: 16009,
          },
          {
            id: 16009005,
            label: '入职标准',
            path: '/hr-staff/join-standards-list',
            pid: 16009,
          },
          {
            id: 16009006,
            label: '员工变动明细',
            path: '/hr-staff/dept-hange-list',
            pid: 16009,
          },
        ]
      },
      {
        id: 16005,
        label: '排班管理',
        path: 'workclass',
        pid: 16,
        children: [{
            id: 16005001,
            label: '班次设置',
            path: '/workclass/class',
            pid: 16005,
            is_menu: false,
            children: [{
                id: 16005001001,
                label: '查询',
                pid: 16005001
              },
              {
                id: 16005001002,
                label: '新增',
                pid: 16005001
              },
              {
                id: 16005001003,
                label: '修改',
                pid: 16005001
              },
              {
                id: 16005001004,
                label: '复制',
                pid: 16005001
              },
              {
                id: 16005001005,
                label: '删除',
                pid: 16005001
              },
            ]
          },
          {
            id: 16005002,
            label: '排班管理',
            path: '/workclass/user',
            pid: 16005,
            is_menu: false,
            children: [{
                id: 16005002001,
                label: '查询',
                pid: 16005002
              },
              {
                id: 16005002002,
                label: '修改',
                pid: 16005002
              },
              {
                id: 16005002003,
                label: '删除',
                pid: 16005002
              },
              {
                id: 16005002004,
                label: '报审',
                pid: 16005002
              },
              {
                id: 16005002005,
                label: '导出',
                pid: 16005002
              },
            ]
          },
          {
            id: 16005003,
            label: '排班审核',
            path: '/workclass/check',
            pid: 16005,
          },
          {
            id: 16005004,
            label: '排班计划表',
            path: '/workclass/schedule',
            pid: 16005,
          }
        ]
      },
      {
        id: 16008,
        label: '考勤管理',
        path: 'workcheck',
        pid: 16,
        children: [{
            id: 16008001,
            label: '考勤机管理',
            path: '/workcheck/app-list',
            pid: 16008,
          },
          {
            id: 16008010,
            label: '新考勤机管理',
            path: '/attendance/machine',
            pid: 16008,
            children:[{
              id: 16008010001,
              label: '仅查看',
              pid: 16008010,
            },{
              id: 16008010002,
              label: '编辑所有',
              pid: 16008010,
            }]
          },
          {
            id: 16008002,
            label: '考勤设置',
            path: '/workcheck/set-list',
            pid: 16008,
          },
          {
            id: 16008006,
            label: '考勤部门',
            path: '/workcheck/department',
            pid: 16008,
          },
          {
            id: 16008003,
            label: '考勤记录',
            path: '/workcheck/work_check_record',
            pid: 16008,
          },
          {
            id: 16008004,
            label: '考勤维护',
            path: '/workcheck/work_check_maintenance',
            pid: 16008,
            children: [{
                id: 16008004008,
                label: '查询',
                pid: 16008004,
              },
              {
                id: 160080040010,
                label: '查看自己',
                pid: 16008004,
              },
              {
                id: 160080040011,
                label: '查看部门',
                pid: 16008004,
              },
              {
                id: 16008004001,
                label: '保存',
                pid: 16008004,
              },
              {
                id: 16008004002,
                label: '导入',
                pid: 16008004,
              },
              {
                id: 16008004003,
                label: '删除',
                pid: 16008004,
              },
              {
                id: 16008004004,
                label: '报审',
                pid: 16008004,
              },
              {
                id: 16008004005,
                label: '日记',
                pid: 16008004,
              },
              {
                id: 16008004006,
                label: '导出',
                pid: 16008004,
              },
              {
                id: 16008004007,
                label: '考勤流程',
                pid: 16008004,
              },
              {
                id: 16008004009,
                label: '编辑实际出勤、计划出勤、忘记签卡、迟到分钟、早退分钟',
                pid: 16008004,
              },
            ]
          },
          {
            id: 16008005,
            label: '考勤审核',
            path: '/workcheck/work_check_examine',
            pid: 16008,
            children: [{
                id: 16008005001,
                label: '查询',
                pid: 16008005,
              },
              {
                id: 16008005002,
                label: '审核通过',
                pid: 16008005,
              },
              {
                id: 16008005003,
                label: '审核不通过',
                pid: 16008005,
              },
              {
                id: 16008005004,
                label: '导出记录',
                pid: 16008005,
              },
            ]
          },
          {
            id: 16008007,
            label: '年休假',
            path: '/workcheck/work_check_annual',
            pid: 16008,
            children: [{
                id: 16008007001,
                label: '查询',
                pid: 16008007,
              },
              {
                id: 16008007002,
                label: '编辑',
                pid: 16008007,
              }
            ]
          },
          {
            id: 16008008,
            label: '调休假',
            path: '/workcheck/work_check_year',
            pid: 16008,
            children: [{
                id: 16008008001,
                label: '查询',
                pid: 16008008,
              },
              {
                id: 16008008002,
                label: '编辑',
                pid: 16008008,
              }
            ]
          }
        ]
      },
      {
        id: 16014,
        label: 'e考勤管理',
        path: '/workcheck/eWorkCheck',
        pid: 16,
        children: [{
            id: 16014001,
            label: '考勤点设置',
            path: '/workcheck/eWorkCheck',
            pid: 16014,
          },
          {
            id: 16014002,
            label: '员工列表',
            path: '/workcheck/eUserList',
            pid: 16014,
          },
          {
            id: 16014003,
            label: '考勤记录',
            path: '/workcheck/eWorkCheckRecord',
            pid: 16014,
          }
        ]
      },
      {
        id: 16006,
        label: '基础设置',
        path: 'hr-setting',
        pid: 16,
        children: [{
            id: 16006001,
            label: '岗位设置',
            path: '/hr-setting/post-setting',
            pid: 16006,
          },
          {
            id: 16006002,
            label: '族群管理',
            path: '/hr-setting/group',
            pid: 16006,
          },
          {
            id: 16006003,
            label: '职位管理',
            path: '/hr-setting/position',
            pid: 16006,
          }, {
            id: 16006008,
            label: '职级设置',
            path: '/hr-setting/rank-setting',
            pid: 16006,
          },
          {
            id: 16006004,
            label: '社保管理',
            path: '/hr-setting/social-insurance',
            pid: 16006,
          },
          {
            id: 16006005,
            label: '公积金管理',
            path: '/hr-setting/fund-manage',
            pid: 16006,
          },
          {
            id: 16006006,
            label: '缴纳关系管理',
            path: '/hr-setting/pay-relation-manage',
            pid: 16006,
          },
          {
            id: 16006007,
            label: '法定单位',
            path: '/hr-setting/legal_unit',
            pid: 16006,
          },
        ]
      },
      {
        id: 16007,
        label: '薪酬管理',
        path: 'hr-salary',
        pid: 16,
        children: [{
            id: 16007001,
            label: '基数设置',
            path: '/hr-salary/basic-setting',
            pid: 16007,
            children: [{
                id: 16007001001,
                label: '查询',
                pid: 16007001,
              },
              {
                id: 16007001002,
                label: '编辑所有数据',
                pid: 16007001,
              },
              {
                id: 16007001003,
                label: '编辑部分数据',
                pid: 16007001,
              },
              {
                id: 16007001004,
                label: '保存操作',
                pid: 16007001,
              },
              {
                id: 16007001005,
                label: '导入',
                pid: 16007001,
              },
              {
                id: 16007001006,
                label: '导出',
                pid: 16007001,
              },
              {
                id: 16007001007,
                label: '基数项目管理',
                pid: 16007001,
              }
            ]
          },
          {
            id: 16007002,
            label: '薪酬设置',
            path: '/hr-salary/salary-setting',
            pid: 16007,
          },
          {
            id: 16007003,
            label: '填报管理',
            path: '/hr-salary/reporting-management',
            pid: 16007,
            children: [{
                id: 1600700301,
                label: '添加审批',
                path: '/hr-setup/reporting-import',
                pid: 16007003,
                children: [

                ],
              },
              {
                id: 1600700302,
                label: '审批明细台账',
                path: '/hr-setup/reporting-report',
                pid: 16007003,
                children: [

                ],
              },
              {
                id: 1600700303,
                label: '填报项设置',
                path: '/hr-setup/reporting-setting',
                pid: 16007003,
                children: [{
                    id: 160070030301,
                    label: '新增',
                    path: '/hr-setup/reporting-add',
                    pid: 1600700303,
                    children: [

                    ],
                  },
                  {
                    id: 160070030302,
                    label: '修改',
                    path: '/hr-setup/reporting-edit',
                    pid: 1600700303,
                    children: [

                    ],
                  },
                  {
                    id: 160070030303,
                    label: '删除',
                    path: '/hr-setup/reporting-del',
                    pid: 1600700303,
                    children: [

                    ],
                  }
                ],
              },
              {
                id: 1600700304,
                label: '明细台账',
                path: '/hr-setup/reporting-detail',
                pid: 16007003,
                children: [{
                  id: 160070030401,
                  label: '导出',
                  path: '/hr-setup/reporting-export',
                  pid: 1600700304,
                  children: [

                  ],
                }],
              }
            ],
          },
          {
            id: 16007004,
            label: '薪酬管理',
            path: '/hr-salary/salary-management-list',
            pid: 16007,
            children: [{
                id: 16007004001,
                label: '查询列表',
                pid: 16007004,
              },
              {
                id: 16007004002,
                label: '新增发放',
                pid: 16007004,
              },
              {
                id: 16007004003,
                label: '计算工资',
                pid: 16007004,
              },
              {
                id: 16007004004,
                label: '提交审批',
                path: '/hr-setup/reporting-sub',
                pid: 16007004,
              },
              {
                id: 16007004005,
                label: '删除',
                path: '/hr-setup/reporting-del',
                pid: 16007004,
              },
              {
                id: 16007004006,
                label: '复制',
                path: '/hr-setup/reporting-copy',
                pid: 16007004,
              },
              {
                id: 16007004007,
                label: '新增线下工资',
                pid: 16007004,
              },
              {
                id: 1600700401,
                label: '发放工资表',
                path: '/hr-salary/salary-management-details',
                pid: 16007004,
                children: [{
                    id: 160070040101,
                    label: '批量调整',
                    pid: 1600700401,
                  },
                  {
                    id: 160070040102,
                    label: '重新计算',
                    pid: 1600700401,
                  },
                  {
                    id: 160070040103,
                    label: '添加员工',
                    pid: 16007004,
                  },
                  {
                    id: 160070040104,
                    label: '检查员工',
                    pid: 1600700401,
                  },
                  {
                    id: 160070040105,
                    label: '修改备注',
                    pid: 1600700401,
                  },
                  {
                    id: 160070040106,
                    label: '删除',
                    pid: 1600700401,
                  },
                  {
                    id: 160070040107,
                    label: '工资项调整',
                    pid: 1600700401,
                  },
                ],
              },

              {
                id: 1600700402,
                label: '审批工资列表',
                path: '/hr-salary/salary-management-report',
                pid: 16007004,
                children: [

                ],
              }
            ],
          },
          {
            id: 16007005,
            label: '月度检查',
            path: '/hr-salary/month-check',
            pid: 16007,
          },
          {
            id: 16007006,
            label: '薪酬明细',
            path: '/hr-salary/salary-details',
            pid: 16007,
          },
          {
            id: 16007007,
            label: '异动检查',
            path: '/hr-salary/cardinal-change',
            pid: 16007,
          },
          {
            id: 16007008,
            label: '补贴管理',
            path: '/hr-salary/subsidy-management',
            pid: 16007,
          },
        ]
      },
      {
        id: 16010,
        label: '奖惩管理',
        path: 'punishments',
        pid: 16,
        children: [{
            id: 16010001,
            label: '奖惩种类设置',
            path: '/punishments/type',
            pid: 16010,
            children: [{
                id: 16010001001,
                label: '查询列表',
                pid: 16010001,
              },
              {
                id: 16010001002,
                label: '新增奖惩类型',
                pid: 16010001,
              },
              {
                id: 16010001003,
                label: '修改奖惩类型',
                pid: 16010001,
              },
              {
                id: 16010001004,
                label: '删除奖惩类型',
                pid: 16010001,
              },
            ],
          },
          {
            id: 16010002,
            label: '奖惩管理',
            path: '/punishments/list',
            pid: 16010,
            children: [{
                id: 16010002001,
                label: '查询列表',
                pid: 16010002,
              },
              {
                id: 16010002002,
                label: '新增奖惩',
                pid: 16010002,
              },
              {
                id: 16010002003,
                label: '导出奖惩明细表',
                pid: 16010002,
              },
              {
                id: 16010002004,
                label: '导入',
                pid: 16010002,
              },
              {
                id: 16010002005,
                label: '查看流程',
                pid: 16010002,
              },
              {
                id: 16010002006,
                label: '修改奖惩记录',
                pid: 16010002,
              },
              {
                id: 16010002007,
                label: '发起流程',
                pid: 16010002,
              },
              {
                id: 16010002008,
                label: '删除奖惩记录',
                pid: 16010002,
              },
            ],
          },
        ]
      },
      {
        id: 16011,
        label: '人事报表',
        icon: 'mdi-eslint',
        path: '/personnelReport/index',
        pid: 16,
        is_menu: true,
        children: [{
          id: 16011001,
          label: '查看与导出',
          pid: 16011,
        }, ]
      },
      {
        id: 16015,
        label: '人力资源统计分析',
        icon: 'mdi-eslint',
        path: '/personnelReport/user-report',
        pid: 16,
        is_menu: true,
        children: [{
          id: 16015001,
          label: '查看',
          pid: 16015,
        },{
          id: 16015002,
          label: '导出',
          pid: 16015,
        }]
      },
      {
        id: 16012,
        label: '培训认证',
        path: '/study',
        pid: 16,
        children: [{
          id: 160120001,
          label: '培训计划',
          path: '/study/train-plan',
          pid: 16012,
          children: [{
              id: 160120001001,
              label: '查看',
              pid: 160120001,
            },
            {
              id: 160120001002,
              label: '编辑',
              pid: 160120001,
            },
            {
              id: 160120001003,
              label: '删除',
              pid: 160120001,
            },
          ]
        }, {
          id: 160120002,
          label: '计划审核',
          path: '/study/train-plan-pass',
          pid: 16012,
          children: [{
              id: 160120002001,
              label: '查看',
              pid: 160120002,
            },
            {
              id: 160120002002,
              label: '编辑',
              pid: 160120002,
            },
            {
              id: 160120002003,
              label: '删除',
              pid: 160120002,
            },
          ]
        }, {
          id: 160120003,
          label: '报名管理',
          path: '/study/train-application',
          pid: 16012,
          children: [{
              id: 160120003001,
              label: '查看',
              pid: 160120003,
            },
            {
              id: 160120003002,
              label: '编辑',
              pid: 160120003,
            },
            {
              id: 160120003003,
              label: '删除',
              pid: 160120003,
            },
          ]
        }, {
          id: 160120004,
          label: '培训管理',
          path: '/study/train-train',
          pid: 16012,
          children: [{
              id: 160120004001,
              label: '查看',
              pid: 160120004,
            },
            {
              id: 160120004002,
              label: '编辑',
              pid: 160120004,
            },
            {
              id: 160120004003,
              label: '删除',
              pid: 160120004,
            },
          ]
        }, ]
      },
      {
        id: 16013,
        label: '劳务公司管理',
        path: '/hr-setting/company',
        pid: 16,
        children: [{
          id: 160130001,
          label: '劳务公司登记',
          path: '/hr-setting/company',
          pid: 16013,
          children: [{
              id: 160130001001,
              label: '查看',
              pid: 160130001,
            },
            {
              id: 160130001002,
              label: '编辑',
              pid: 160130001,
            }
          ],
        }, ]
      }
    ]
  },
  {
    id: 31,
    label: '在线学习',
    path: '/study/index',
    pid: 0,
    is_menu: true,
    children: [{
        id: 3101,
        label: '首页',
        path: '/study/index',
        pid: 31,
      },
      {
        id: 3105,
        label: '课程管理',
        path: '/study/lesson-list',
        pid: 31,
        children: [{
          id: 31050001,
          label: '课程管理',
          path: '/study/lesson-list',
          pid: 3105,
          children: [],
        }, {
          id: 31050002,
          label: '课程分类',
          path: '/study/course-category-list',
          pid: 3105,
          children: [],
        }]
      },
      {
        id: 3103,
        label: '我的学习',
        path: '/study/questionBank',
        pid: 31,
        children: [{
            id: 31030001,
            label: '我的必修课',
            path: '/study/required-course',
            pid: 3103,
            children: [],
          },
          {
            id: 31030002,
            label: '我的选修课',
            path: '/study/elective-courses',
            pid: 3103,
            children: [],
          },
          {
            id: 31030003,
            label: '我的考试',
            path: '/study/myExam-list',
            pid: 3103,
            children: [],
          },
        ]
      },
      {
        id: 3104,
        label: '学习班管理',
        path: '/study/requiredCourse-manage',
        pid: 31,
        children: [{
          id: 31040001,
          label: '必修课管理',
          path: '/study/requiredCourse-manage',
          pid: 3104,
          children: [],
        }, ]
      },
      {
        id: 3102,
        label: '考试管理',
        path: '/study/questionBank',
        pid: 31,
        children: [{
            id: 31020001,
            label: '题库管理',
            path: '/study/questionBank',
            pid: 3102,
            children: [],
          },
          {
            id: 31020002,
            label: '试卷管理',
            path: '/study/testPaper',
            pid: 3102,
            children: [],
          },
          {
            id: 31020004,
            label: '成绩查询',
            path: '/study/Exam-list',
            pid: 3102,
            children: [],
          },
          {
            id: 31020005,
            label: '报名审核',
            path: '/study/registration-review',
            pid: 3102,
            children: [],
          },
          {
            id: 31020003,
            label: '试卷批改',
            path: '/study/correct-list',
            pid: 3102,
            children: [],
          },
        ]
      }
    ]
  },
  {
    id: 32,
    label: '采购管理',
    path: '/procure/product-list',
    pid: 0,
    is_menu: true,
    children: [
      {
        id: 3201,
        label: '仓储设置',
        path: '/procure/product-list',
        pid: 32,
        children: [
          {
            id: 32010001,
            label: '物料管理',
            path: '/procure/product-list',
            pid: 3201,
            children: [],
          },
          {
            id: 32010002,
            label: '物料分类',
            path: '/procure/product-category-list',
            pid: 3201,
            children: [],
          },
          // {
          //   id: 32010003,
          //   label: '出入库记录',
          //   path: '/procure/storagelog-list',
          //   pid: 3201,
          //   children: [],
          // },
          {
            id: 32010004,
            label: '仓库管理',
            path: '/procure/warehouse-list',
            pid: 3201,
            children: [],
          },

          // {
          //   id: 32010005,
          //   label: '仓库绑定管理',
          //   path: '/procure/warehouse-bind-list',
          //   pid: 3201,
          //   children: [],
          // },
        ],
      },
      {
        id: 3202,
        label: '仓储管理',
        path: '/procure/materialRequisition-list',
        pid: 32,
        children: [
          {
            id: 32020001,
            label: '物料申购',
            path: '/procure/materialRequisition-list',
            pid: 3202,
            children: [],
          },
          {
            id: 32020002,
            label: '申购单审核',
            path: '/procure/materialRequisition-examine',
            pid: 3202,
            children: [],
          },
          {
            id: 32020003,
            label: '申购入库单',
            path: '/procure/storehouse-in',
            pid: 3202,
            children: [],
          },
          {
            id: 32020004,
            label: '物料入库单',
            path: '/procure/storehouse-in-direct',
            pid: 3202,
            children: [],
          },
          {
            id: 32020005,
            label: '入库单审核',
            path: '/procure/storehouse-in-approval',
            pid: 3202,
            children: [],
          },
          // {
          //   id: 32020006,
          //   label: '物料申领单',
          //   path: '/procure/product-list',
          //   pid: 3202,
          //   children: [],
          // },
          {
            id: 32020007,
            label: '物料出库单',
            path: '/procure/storehouse-out',
            pid: 3202,
            children: [],
          },
          {
            id: 32020008,
            label: '出库单审核',
            path: '/procure/storehouse-out-approval',
            pid: 3202,
            children: [],
          },
        ]
      },
      {
        id: 3205,
        label: '供应商',
        path: '/procure/supplier-list',
        pid: 32,
      },
      {
        id: 3206,
        label: '报价',
        path: '/procure/engineeringQuotation',
        pid: 32,
        children: [
          {
            id: 32060001,
            label: '报价单',
            path: '/procure/engineeringQuotation',
            pid: 3206,
            children: [],
          },
          {
            id: 32060002,
            label: '销售价目表',
            path: '/procure/SaleQuotation',
            pid: 3206,
            children: [],
          },
        ],
      },
      {
        id: 3207,
        label: '报表汇总',
        path: '/procure/MaterialApplyBuyBillReport',
        pid: 32,
        children: [
          {
            id: 32070001,
            label: '采购单明细表',
            path: '/procure/MaterialApplyBuyBillReport',
            pid: 3207,
            children: [],
          },
        ],
      },
    ]
  },
  {
    id: 29,
    label: '预算管理',
    icon: 'mdi-home-outline',
    path: '/budget/account-list',
    pid: 0,
    is_menu: true,
    children: [{
        id: 29001,
        label: '预算管理',
        path: 'budget',
        pid: 29,
        children: [{
            id: 29001001,
            label: '科目代码',
            icon: 'mdi-eslint',
            path: '/budget/account-list',
            pid: 29001,
            children: [{
                id: 29001001001,
                label: '查看',
                pid: 29001001,
              },
              {
                id: 29001001002,
                label: '导入科目',
                pid: 29001001,
              },
            ]
          },
          {
            id: 29001002,
            label: '预算计划预览',
            icon: 'mdi-eslint',
            path: '/budget/plan-task',
            pid: 29001,
            children: [{
                id: 29001002001,
                label: '查看',
                pid: 29001002,
              },
              {
                id: 29001002002,
                label: '导入预算计划',
                pid: 29001002,
              },
            ]
          }, {
            id: 29001003,
            label: '预算计划',
            icon: 'mdi-eslint',
            path: '/budget/budget-plan',
            pid: 29001,
            children: [{
                id: 29001003003,
                label: '查看',
                pid: 29001003,
              },
              {
                id: 29001003001,
                label: '删除',
                pid: 29001003,
              },
              {
                id: 29001003002,
                label: '强制删除',
                pid: 29001003,
              },
            ]
          },
          {
            id: 29001004,
            label: '预算调整',
            icon: 'mdi-eslint',
            path: '/budget/adjust-apply',
            pid: 29001,
            is_menu: true,
          },
          {
            id: 29001005,
            label: '费用报销',
            icon: 'mdi-eslint',
            path: '/budget/expense-apply',
            pid: 29001,
            is_menu: true,
          },
          {
            id: 29001006,
            label: '月度资金计划',
            icon: 'mdi-eslint',
            path: '/budget/budget-apply',
            pid: 29001,
            is_menu: true,
          },
          {
            id: 29001007,
            label: '费用报销统计表',
            icon: 'mdi-eslint',
            path: '/budget/expense-apply-summary',
            pid: 29001,
            children: [{
              id: 29001007001,
              label: '导出',
              pid: 29001007,
            }, ]
          },
          {
            id: 29001008,
            label: '费用申请统计表',
            icon: 'mdi-eslint',
            path: '/budget/budget-apply-summary',
            pid: 29001,
            children: [{
              id: 29001008001,
              label: '导出',
              pid: 29001008,
            }, ]
          },
        ]
      },
      {
        id: 29002,
        label: '预算报表',
        icon: 'mdi-eslint',
        path: '/budget/expense-apply-summary',
        pid: 29,
        is_menu: true,
        children: [{
          id: 29002001,
          label: '导出',
          pid: 29002,
        }, ]
      }
    ]
  },
  {
    id: 21,
    label: '工程管理',
    path: '',
    pid: 0,
    is_menu: true,
    children: [{
        id: 21001,
        label: '智慧校园',
        path: '',
        pid: 21,
        children: [{
            id: 21001001,
            label: '学生缴费',
            path: '/school/goodslist',
            pid: 21001,
          },
          {
            id: 21001002,
            label: '月统计',
            path: '/school/getStatement',
            pid: 21001,
          },
          {
            id: 21001003,
            label: '缴费统计',
            path: '/school/chartStatistics',
            pid: 21001,
          },
        ]
      },
      {
        id: 21003,
        label: '能耗管理',
        path: '',
        pid: 21,
        children: [
          // {
          //   id: 21003001,
          //   label: '住户管理',
          //   path: '/secp/memberHouse',
          //   pid: 21003,
          // },
          // {
          //   id: 21003002,
          //   label: '用能分区',
          //   path: '/secp/energyRegion',
          //   pid: 21003,
          // },
          {
            id: 21003003,
            label: '结算方案',
            path: '/secp/settlementPlan',
            pid: 21003,
          },
          {
            id: 21003004,
            label: '用能抄表',
            path: '/secp/meterNoteDetail',
            pid: 21003,
          },
          {
            id: 21003005,
            label: '账单查询',
            path: '/secp/order',
            pid: 21003,
          },
          {
            id: 21003006,
            label: '资产管理',
            path: '/secp/type',
            pid: 21003,
          },
          {
            id: 21003007,
            label: '用能用途',
            path: '/secp/use',
            pid: 21003,
          },
          {
            id: 21003008,
            label: '用能类型管理',
            path: '/secp/useType',
            pid: 21003,
          },
          {
            id: 21003012,
            label: '统计分析',
            path: '/secp/chartStatistics',
            pid: 21003,
          },
          {
            id: 21003013,
            label: '用能预警',
            path: '/secp/useWarn',
            pid: 21003,
          },
          {
            id: 21003014,
            label: '预警分析',
            path: '/secp/chartUseWarn',
            pid: 21003,
          },

        ]
      },
      // {
      //   id: 21002,
      //   label: '项目管理',
      //   path: 'https://tf.jdy.com/sec/ierp/login.html',
      //   pid: 21,
      // },
      {
        id: 21005,
        label: '电梯维保',
        path: '/maintenance',
        pid: 21,
        children: [{
            id: 21005001,
            label: '维保统计',
            path: '/maintenance/index',
            pid: 21005,
          },
          {
            id: 21005002,
            label: '维保排期',
            pid: 21005,
            is_menu: true,
            children: [{
                id: 21005002001,
                label: '保养计划',
                path: '/maintenance/plan',
                pid: 21005002,
              },
              {
                id: 21005002002,
                label: '保养排期',
                path: '/maintenance/schedule',
                pid: 21005002,
              },
              {
                id: 21005002003,
                label: '电梯管理',
                path: '/maintenance/elevator-list',
                pid: 21005002,
              },
              {
                id: 21005002004,
                label: '使用单位',
                path: '/maintenance/customer-list',
                pid: 21005002,
              },
              {
                id: 21005002005,
                label: '项目管理',

                path: '/maintenance/project-list',
                pid: 21005002,
              },
              {
                id: 21005002006,
                label: '电梯信息审核',
                path: '/maintenance/elevator-check',
                pid: 21005002,
              },
            ]
          },
          {
            id: 21005003,
            label: '维保工单',
            pid: 21005,
            is_menu: true,
            children: [{
                id: 21005003001,
                label: '保养单',
                path: '/maintenance/work-order',
                pid: 21005003,
              },
              {
                id: 21005003002,
                label: '急修单',
                path: '/maintenance/urgent-order',
                pid: 21005003,
              },
              {
                id: 21005003003,
                label: '急修单审核',
                path: '/maintenance/repair-order',
                pid: 21005003,
              },
              {
                id: 21005003004,
                label: '工单审核',
                path: '/maintenance/order-check',
                pid: 21005003,
              },
              {
                id: 21005003005,
                label: '评分表',
                path: '/maintenance/work-comment',
                pid: 21005003,
              },
            ]
          },
          {
            id: 21005004,
            label: '维保人员',
            pid: 21005,
            is_menu: true,
            children: [{
                id: 21005004001,
                label: '班组管理',
                path: '/maintenance/user-group',
                pid: 21005004,
              },
              {
                id: 21005004002,
                label: '证件管理',
                path: '/maintenance/user-certificate',
                pid: 21005004,
              },
            ]
          },
          {
            id: 21005006,
            label: '销售管理',
            pid: 21005,
            is_menu: true,
            children: [{
                id: 21005006001,
                label: '合同管理',
                path: '/maintenance/contract-manage',
                pid: 21005006,
              },
              // {
              //   id: 21005006002,
              //   label: '合同审核',
              //   path: '/maintenance/contract-review',
              //   pid: 21005006,
              // },
              // {
              //   id: 21005006003,
              //   label: '销售参数',
              //   path: '/maintenance/contract-params',
              //   pid: 21005006,
              // },
            ]
          },
          {
            id: 21005005,
            label: '维保设置',
            pid: 21005,
            is_menu: true,
            children: [{
                id: 21005005001,
                label: '维保参数',
                path: '/maintenance/config',
                pid: 21005005,
              },
              {
                id: 21005005002,
                label: '维保项',
                path: '/maintenance/template',
                pid: 21005005,
              },
            ]
          }
        ]
      },
      {
        id: 21010,
        label: '工程维保',
        path: '/device-maintenance',
        pid: 21,
        children: [
          {
            id: 21010001,
            label: '项目管理',
            path: '/device-maintenance/project',
            pid: 21010,
          },
          {
            id: 21010003,
            label: '标准管理',
            path: '/device-maintenance/desc',
            pid: 21010,
          },
          {
            id: 21010004,
            label: '设备分类',
            path: '/device-maintenance/category',
            pid: 21010,
          },
          {
            id: 21010005,
            label: '设备管理',
            path: '/device-maintenance/device',
            pid: 21010,
          },
          // {
          //   id: 21010002,
          //   label: '人员管理',
          //   path: '/device-maintenance/user',
          //   pid: 21010,
          // },
          {
            id: 21010006,
            label: '计划管理',
            path: '/device-maintenance/schedule',
            pid: 21010,
            is_menu: false,
            children: [
              {
                id: 21010006001,
                label: '编辑计划',
                pid: 21010006,
              },
              {
                id: 21010006002,
                label: '审核计划',
                pid: 21010006,
              }
            ]
          },
          {
            id: 21010007,
            label: '维保记录',
            path: '/device-maintenance/record',
            pid: 21010,
          },
          {
            id: 21010008,
            label: '整改记录',
            path: '/device-maintenance/repair',
            pid: 21010,
          },
          {
            id: 21010009,
            label: '抽检模板',
            path: '/device-maintenance/check-template',
            pid: 21010,
          },
          {
            id: 21010010,
            label: '抽检记录',
            path: '/device-maintenance/check-record',
            pid: 21010,
          },
          {
            id: 21010011,
            label: '设备维修',
            path: '/device-maintenance/fix',
            pid: 21010,
          },
        ]
      },
      {
        id: 21007,
        label: '消防维保',
        path: '/fireproof',
        pid: 21,
        children: [
          {
            id: 21007001,
            label: '维保统计',
            path: '/fireproof/index',
            pid: 21007,
          },
          {
            id: 21007002,
            label: '维保管理',
            pid: 21007,
            is_menu: true,
            children: [{
                id: 21007002001,
                label: '项目管理',
                path: '/fireproof/project',
                pid: 21007002,
              },
              // {
              //   id: 21007002004,
              //   label: '维保排期',
              //   path: '/fireproof/schedule',
              //   pid: 21007002,
              // },
              {
                id: 21007002002,
                label: '维保计划',
                path: '/fireproof/schedule',
                pid: 21007002,
              },
              {
                id: 21007002003,
                label: '线下报告',
                path: '/fireproof/report',
                pid: 21007002,
              },
            ]
          },
          {
            id: 21007003,
            label: '维保工单',
            pid: 21007,
            is_menu: true,
            children: [{
                id: 21007003001,
                label: '保养单',
                path: '/fireproof/work-order',
                pid: 21007003,
              },
              {
                id: 21007003002,
                label: '急修单',
                path: '/fireproof/urgent-order',
                pid: 21007003,
              },
              {
                id: 21007003003,
                label: '急修单审核',
                path: '/fireproof/repair-order',
                pid: 21007003,
              },
              {
                id: 21007003004,
                label: '工单审核',
                path: '/fireproof/order-check',
                pid: 21007003,
              },
            ]
          },
          {
            id: 21007006,
            label: '合同管理',
            path: '/fireproof/contract-manage',
            pid: 21007,
          },
          {
            id: 21007005,
            label: '基础信息管理',
            pid: 21007,
            is_menu: true,
            children: [{
                id: 21007005001,
                label: '用户信息管理',
                path: '/fireproof/worker',
                pid: 21007005,
              },
              {
                id: 21007005002,
                label: '维保标准内容',
                path: '/fireproof/template',
                pid: 21007005,
              },
            ]
          }
        ]
      },
      {
        id: 21008,
        label: '智能维保',
        path: '/intellect',
        pid: 21,
        children: [
          {
            id: 21008001,
            label: '维保统计',
            path: '/intellect/index',
            pid: 21008,
          },
          {
            id: 21008002,
            label: '维保排期',
            pid: 21008,
            is_menu: true,
            children: [{
                id: 21008002001,
                label: '保养计划',
                path: '/intellect/plan',
                pid: 21008002,
              },
              {
                id: 21008002002,
                label: '保养排期',
                path: '/intellect/schedule',
                pid: 21008002,
              },
              {
                id: 21008002003,
                label: '产品管理',
                path: '/intellect/equipment',
                pid: 21008002,
              },
              {
                id: 21008002004,
                label: '使用单位',
                path: '/intellect/customer',
                pid: 21008002,
              },
              {
                id: 21008002005,
                label: '项目管理',

                path: '/intellect/project',
                pid: 21008002,
              },
              {
                id: 21008002006,
                label: '产品信息审核',
                path: '/intellect/elevator-check',
                pid: 21008002,
              },
            ]
          },
          {
            id: 21008003,
            label: '维保工单',
            pid: 21008,
            is_menu: true,
            children: [{
                id: 21008003001,
                label: '保养单',
                path: '/intellect/work-order',
                pid: 21008003,
              },
              {
                id: 21008003002,
                label: '急修单',
                path: '/intellect/urgent-order',
                pid: 21008003,
              },
              {
                id: 21008003003,
                label: '急修单审核',
                path: '/intellect/repair-order',
                pid: 21008003,
              },
              {
                id: 21008003004,
                label: '工单审核',
                path: '/intellect/order-check',
                pid: 21008003,
              },
            ]
          },
          {
            id: 21008004,
            label: '维保人员',
            pid: 21008,
            is_menu: true,
            children: [{
                id: 21008004001,
                label: '班组管理',
                path: '/intellect/user-group',
                pid: 21008004,
              },
              {
                id: 21008004002,
                label: '证件管理',
                path: '/intellect/user-certificate',
                pid: 21008004,
              },
            ]
          },
          {
            id: 21008006,
            label: '销售管理',
            pid: 21008,
            is_menu: true,
            children: [{
                id: 21008006001,
                label: '合同管理',
                path: '/intellect/contract-manage',
                pid: 21008006,
              }
            ]
          },
          {
            id: 21008005,
            label: '维保设置',
            pid: 21008,
            is_menu: true,
            children: [{
                id: 21008005001,
                label: '维保参数',
                path: '/intellect/config',
                pid: 21008005,
              },
              {
                id: 21008005002,
                label: '维保项',
                path: '/intellect/template',
                pid: 21008005,
              },
            ]
          }
        ]
      },
      {
        id: 21006,
        label: '智慧停车',
        path: '/park',
        pid: 21,
        children: [
          {
            id: 21006001,
            label: '停车场列表',
            path: '/park/index',
            pid: 21006,
          },
          {
            id: 21006002,
            label: '支付汇总表',
            path: '/park/income',
            pid: 21006,
          },
        ]
      }
    ]
  },
  {
    id: 30,
    label: '能耗管理',
    path: '',
    pid: 0,
    is_menu: true,
    children: [{
        id: 21004,
        label: '公共能耗',
        path: '/meter/meter?type=2',
        pid: 30,
        children: [{
            id: 21004001,
            label: '仪表登记',
            icon: 'mdi-home-outline ',
            path: '/meter/meter?type=2',
            pid: 21004,
            // is_menu: true,
            children: [{
                id: 21004001000,
                label: '查看',
                pid: 21004001,
              },
              {
                id: 21004001001,
                label: '添加',
                pid: 21004001,
              },
              {
                id: 21004001002,
                label: '导入',
                pid: 21004001,
              },
              {
                id: 21004001003,
                label: '删除',
                pid: 21004001,
              },
              {
                id: 21004001004,
                label: '批量修改收费标准',
                pid: 21004001,
              },
              {
                id: 21004001005,
                label: '批量停用',
                pid: 21004001,
              },
              {
                id: 21004001006,
                label: '能耗',
                pid: 21004001,
              },
              {
                id: 21004001007,
                label: '换表',
                pid: 21004001,
              },
              {
                id: 21004001008,
                label: '移表',
                pid: 21004001,
              },
              // {
              //   id: 21004001000,
              //   label: '查看',
              //   pid: 21004001,
              // },
              // {
              //   id: 21004001001,
              //   label: '添加',
              //   pid: 21004001,
              // },
              // {
              //   id: 21004001002,
              //   label: '导入',
              //   pid: 21004001,
              // },
              // {
              //   id: 21004001003,
              //   label: '删除',
              //   pid: 21004001,
              // },
              // {
              //   id: 21004001004,
              //   label: '批量修改收费标准',
              //   pid: 21004001,
              // },
              // {
              //   id: 21004001005,
              //   label: '批量停用',
              //   pid: 21004001,
              // },
              // {
              //   id: 21004001006,
              //   label: '能耗',
              //   pid: 21004001,
              // },
              // {
              //   id: 21004001007,
              //   label: '换表',
              //   pid: 21004001,
              // },
              // {
              //   id: 21004001008,
              //   label: '移表',
              //   pid: 21004001,
              // },
            ]
          },
          {
            id: 21004002,
            label: '仪表抄表',
            icon: 'mdi-home-outline ',
            path: '/meter/meterNote?type=2',
            pid: 21004,
            is_menu: false,
            children: [{
                id: 21004002000,
                label: '查看',
                pid: 21004002,
              },
              {
                id: 21004002001,
                label: '全部删除',
                pid: 21004002,
              },
              {
                id: 21004002002,
                label: '抄表',
                pid: 21004002,
              },
              {
                id: 21004002003,
                label: '录入',
                pid: 21004002,
              },
              {
                id: 21004002004,
                label: '全部审核',
                pid: 21004002,
              },
              {
                id: 21004002005,
                label: '全部反审核',
                pid: 21004002,
              },
              {
                id: 21004002006,
                label: '能耗分析',
                pid: 21004002,
              },
              {
                id: 21004002007,
                label: '删除',
                pid: 21004002,
              },
              {
                id: 21004002008,
                label: '审核',
                pid: 21004002,
              },
              {
                id: 21004002009,
                label: '反审核',
                pid: 21004002,
              },
              {
                id: 21004002010,
                label: '流程审核',
                pid: 21004002,
              },
              {
                id: 21004002011,
                label: '全部流程审批',
                pid: 21004002,
              },
            ]
          },
          // {
          //   id: 21004006,
          //   label: '仪表合并费项',
          //   path: '/meter/MeterFeeTag?type=2',
          //   pid: 21004
          // },
          {
            id: 21004004,
            label: '抄表计费',
            path: '/meter/MeterOrder?type=2',
            pid: 21004
          },
          {
            id: 21004005,
            label: '分摊模板',
            path: '/meter/ApportionTemplate?type=2',
            pid: 21004
          },
          {
            id: 21004003,
            label: '抄表明细',
            icon: 'mdi-home-outline ',
            path: '/meter/meterNoteDetail?type=2',
            pid: 21004,
            is_menu: true
          },
          {
            id: 21004008,
            label: '数据完整分析',
            icon: 'mdi-eslint ',
            // path: '/cockpit/EnergyConsumptionStatistics',
            // path: '/stat/chart',
            path: '/stat/meterInformation',
            pid: 21004,
          },
          {
            id: 21004007,
            label: '能耗分析',
            icon: 'mdi-eslint ',
            // path: '/cockpit/EnergyConsumptionStatistics',
            // path: '/stat/chart',
            path: '/stat/publicShareMeter',
            pid: 21004,
          },
        ],
      },
      {
        id: 8006,
        label: '业主能耗',
        path: '/meter/meter?type=1',
        pid: 30,
        children: [{
            id: 8006001,
            label: '仪表登记',
            icon: 'mdi-home-outline ',
            path: '/meter/meter?type=1',
            pid: 8006,
            // is_menu: true,
            children: [{
                id: 8006001000,
                label: '查看',
                pid: 8006001,
              },
              {
                id: 8006001001,
                label: '添加',
                pid: 8006001,
              },
              {
                id: 8006001002,
                label: '导入',
                pid: 8006001,
              },
              {
                id: 8006001003,
                label: '删除',
                pid: 8006001,
              },
              {
                id: 8006001004,
                label: '批量修改收费标准',
                pid: 8006001,
              },
              {
                id: 8006001005,
                label: '批量停用',
                pid: 8006001,
              },
              {
                id: 8006001006,
                label: '能耗',
                pid: 8006001,
              },
              {
                id: 8006001007,
                label: '换表',
                pid: 8006001,
              },
              {
                id: 8006001008,
                label: '移表',
                pid: 8006001,
              },
              // {
              //   id: 8006001000,
              //   label: '查看',
              //   pid: 8006001,
              // },
              // {
              //   id: 8006001001,
              //   label: '添加',
              //   pid: 8006001,
              // },
              // {
              //   id: 8006001002,
              //   label: '导入',
              //   pid: 8006001,
              // },
              // {
              //   id: 8006001003,
              //   label: '删除',
              //   pid: 8006001,
              // },
              // {
              //   id: 8006001004,
              //   label: '批量修改收费标准',
              //   pid: 8006001,
              // },
              // {
              //   id: 8006001005,
              //   label: '批量停用',
              //   pid: 8006001,
              // },
              // {
              //   id: 8006001006,
              //   label: '能耗',
              //   pid: 8006001,
              // },
              // {
              //   id: 8006001007,
              //   label: '换表',
              //   pid: 8006001,
              // },
              // {
              //   id: 8006001008,
              //   label: '移表',
              //   pid: 8006001,
              // },
            ]
          },
          {
            id: 8006002,
            label: '仪表抄表',
            icon: 'mdi-home-outline ',
            path: '/meter/meterNote?type=1',
            pid: 8006,
            is_menu: false,
            children: [{
                id: 8006002000,
                label: '查看',
                pid: 8006002,
              },
              {
                id: 8006002001,
                label: '全部删除',
                pid: 8006002,
              },
              {
                id: 8006002002,
                label: '抄表',
                pid: 8006002,
              },
              {
                id: 8006002003,
                label: '录入',
                pid: 8006002,
              },
              {
                id: 8006002004,
                label: '全部审核',
                pid: 8006002,
              },
              {
                id: 8006002005,
                label: '全部反审核',
                pid: 8006002,
              },
              {
                id: 8006002006,
                label: '能耗分析',
                pid: 8006002,
              },
              {
                id: 8006002007,
                label: '删除',
                pid: 8006002,
              },
              {
                id: 8006002008,
                label: '审核',
                pid: 8006002,
              },
              {
                id: 8006002009,
                label: '反审核',
                pid: 8006002,
              },
              {
                id: 8006002010,
                label: '流程审核',
                pid: 8006002,
              },
              {
                id: 8006002011,
                label: '全部流程审批',
                pid: 8006002,
              },
            ]
          },
          // {
          //   id: 8006005,
          //   label: '仪表合并费项',
          //   path: '/meter/MeterFeeTag?type=1',
          //   pid: 8006
          // },
          {
            id: 8006004,
            label: '抄表计费',
            path: '/meter/MeterOrder?type=1',
            pid: 8006
          },
          {
            id: 8006006,
            label: '分摊模板',
            path: '/meter/ApportionTemplate?type=1',
            pid: 8006
          },
          {
            id: 8006003,
            label: '抄表明细',
            icon: 'mdi-home-outline ',
            path: '/meter/meterNoteDetail?type=1',
            pid: 8006,
            is_menu: false,
          },
        ],
      },

      // {
      //   id: 30004,
      //   label: '仪表管理（新版）',
      //   path: '/EnergyConsumption/meter',
      //   pid: 30,
      //   children: [{
      //       id: 30004001,
      //       label: '仪表登记',
      //       icon: 'mdi-home-outline ',
      //       path: '/EnergyConsumption/meter',
      //       pid: 30004,
      //       // is_menu: true,
      //       children: [{
      //           id: 30004001000,
      //           label: '查看',
      //           pid: 30004001,
      //         },
      //         {
      //           id: 30004001001,
      //           label: '添加',
      //           pid: 30004001,
      //         },
      //         {
      //           id: 30004001002,
      //           label: '导入',
      //           pid: 30004001,
      //         },
      //         {
      //           id: 30004001003,
      //           label: '删除',
      //           pid: 30004001,
      //         },
      //         {
      //           id: 30004001004,
      //           label: '批量修改收费标准',
      //           pid: 30004001,
      //         },
      //         {
      //           id: 30004001005,
      //           label: '批量停用',
      //           pid: 30004001,
      //         },
      //         {
      //           id: 30004001006,
      //           label: '能耗',
      //           pid: 30004001,
      //         },
      //         {
      //           id: 30004001007,
      //           label: '换表',
      //           pid: 30004001,
      //         },
      //         {
      //           id: 30004001008,
      //           label: '移表',
      //           pid: 30004001,
      //         },
      //       ]
      //     },
      //     {
      //       id: 30004002,
      //       label: '仪表抄表',
      //       icon: 'mdi-home-outline ',
      //       path: '/EnergyConsumption/meterNote',
      //       pid: 30004,
      //       is_menu: false,
      //       children: [{
      //           id: 30004002000,
      //           label: '查看',
      //           pid: 30004002,
      //         },
      //         {
      //           id: 30004002001,
      //           label: '全部删除',
      //           pid: 30004002,
      //         },
      //         {
      //           id: 30004002002,
      //           label: '抄表',
      //           pid: 30004002,
      //         },
      //         {
      //           id: 30004002003,
      //           label: '录入',
      //           pid: 30004002,
      //         },
      //         {
      //           id: 30004002004,
      //           label: '全部审核',
      //           pid: 30004002,
      //         },
      //         {
      //           id: 30004002005,
      //           label: '全部反审核',
      //           pid: 30004002,
      //         },
      //         {
      //           id: 30004002006,
      //           label: '能耗分析',
      //           pid: 30004002,
      //         },
      //         {
      //           id: 30004002007,
      //           label: '删除',
      //           pid: 30004002,
      //         },
      //         {
      //           id: 30004002008,
      //           label: '审核',
      //           pid: 30004002,
      //         },
      //         {
      //           id: 30004002009,
      //           label: '反审核',
      //           pid: 30004002,
      //         },
      //         {
      //           id: 30004002010,
      //           label: '流程审核',
      //           pid: 30004002,
      //         },
      //         {
      //           id: 30004002011,
      //           label: '全部流程审批',
      //           pid: 30004002,
      //         },
      //       ]
      //     },
      //     {
      //       id: 30004004,
      //       label: '抄表计费',
      //       path: '/meter/MeterOrder',
      //       pid: 30004
      //     },
      //     {
      //       id: 30004003,
      //       label: '仪表抄表明细',
      //       icon: 'mdi-home-outline ',
      //       path: '/EnergyConsumption/meterNoteDetail',
      //       pid: 30004,
      //       is_menu: true
      //     },
      //   ],
      // },
    ]
  },
  {
    id: 15,
    label: '业务拓展',
    path: '/zhoaocf/ledger-list',
    pid: 0,
    children: [{
      id: 15001,
      label: '价值信息',
      path: '/zhoaocf/ledger-list',
      pid: 15,
    },
    {
      id: 15005,
      label: '权责流程',
      path: '/zhoaocf/process-list',
      pid: 15,
      children: [{
        id: 15001001,
        label: '项目流程',
        path: '/zhoaocf/process-list',
        pid: 15005,
      },{
        id: 15001002,
        label: '权责类别',
        path: '/zhoaocf/process-type',
        pid: 15005,
      }]
    },
    {

      id: 15002,
      label: '项目业态',
      path: '/zhoaocf/type-list',
      pid: 15
    },
    {
      id: 15003,
      label: '项目分类',
      path: '/zhoaocf/category-list',
      pid: 15
    },
    {
      id: 15004,
      label: '拓展单位',
      path: '/zhoaocf/region-list',
      pid: 15
    }]
  },
  {
    id: 22,
    label: '秩序维护',
    icon: 'mdi-home-outline ',
    path: '',
    pid: 0,
    is_menu: true,
  },
  // {
  //   id: 23,
  //   label: '环境绿化',
  //   icon: 'mdi-home-outline ',
  //   path: '/',
  //   pid: 0,
  //   children: [{
  //       id: 11004,
  //       label: '工资管理',
  //       icon: 'mdi-eslint ',
  //       path: '/Oa/PreUserManage',
  //       pid: 23,
  //       children: [
  //         {
  //           id: 11004004,
  //           label: '薪资管理',
  //           icon: 'mdi-home-outline ',
  //           path: '/Oa/PreSalary',
  //           pid: 11004,
  //           is_menu: true
  //         },

  //         {
  //           id: 11004006,
  //           label: '奖惩记录',
  //           icon: 'mdi-home-outline ',
  //           path: '/Oa/RewardList',
  //           pid: 11004,
  //           is_menu: true
  //         }, {
  //           id: 11004007,
  //           label: '薪资列表',
  //           icon: 'mdi-home-outline ',
  //           path: '/Oa/SalaryOrigin',
  //           pid: 11004,
  //           is_menu: true
  //         }, {
  //           id: 11004008,
  //           label: '社保管理',
  //           icon: 'mdi-home-outline ',
  //           path: '/Oa/SocialSecurityList',
  //           pid: 11004,
  //           is_menu: true
  //         }
  //       ]
  //     },
  //     {
  //       id: 12,
  //       label: '合同管理',
  //       icon: 'mdi-eslint ',
  //       path: '/Contract',
  //       pid: 23,
  //       children: [{
  //           id: 12001,
  //           label: '合同管理',
  //           icon: 'mdi-eslint ',
  //           path: '/Contract',
  //           pid: 12,
  //           is_menu: true,
  //           children: [{
  //               id: 12001001,
  //               label: '业务类型',
  //               icon: 'mdi-eslint ',
  //               path: '/Contract/Business',
  //               pid: 12001,
  //               children: [{
  //                   id: 12001001001,
  //                   label: '添加类型',
  //                   pid: 12001001,
  //                 },
  //                 {
  //                   id: 12001001002,
  //                   label: '编辑类型',
  //                   pid: 12001001,
  //                 },
  //               ]
  //             },
  //             {
  //               id: 12001002,
  //               label: '组织架构',
  //               icon: 'mdi-eslint ',
  //               path: '/Contract/Area',
  //               pid: 12001,
  //               children: [{
  //                   id: 12001002001,
  //                   label: '添加区域',
  //                   pid: 12001002,
  //                 },
  //                 {
  //                   id: 12001002002,
  //                   label: '编辑区域',
  //                   pid: 12001002,
  //                 },
  //                 {
  //                   id: 12001002003,
  //                   label: '删除区域',
  //                   pid: 12001002,
  //                 },
  //               ]
  //             },
  //             {
  //               id: 12001005,
  //               label: '合作伙伴',
  //               icon: 'mdi-eslint ',
  //               path: '/Contract/Partnership',
  //               pid: 12001,
  //               children: [{
  //                   id: 12001005001,
  //                   label: '添加合作伙伴',
  //                   pid: 12001005,
  //                 },
  //                 {
  //                   id: 12001005002,
  //                   label: '编辑合作伙伴',
  //                   pid: 12001005,
  //                 },
  //                 {
  //                   id: 12001005003,
  //                   label: '删除合作伙伴',
  //                   pid: 12001005,
  //                 },
  //               ]
  //             },
  //             {
  //               id: 12001003,
  //               label: '项目管理',
  //               icon: 'mdi-eslint ',
  //               path: '/Contract/ContractProject',
  //               pid: 12001,
  //               children: [{
  //                   id: 12001003001,
  //                   label: '项目导入',
  //                   pid: 12001003,
  //                 },
  //                 {
  //                   id: 12001003002,
  //                   label: '项目导出',
  //                   pid: 12001003,
  //                 },
  //                 {
  //                   id: 12001003003,
  //                   label: '创建项目',
  //                   pid: 12001003,
  //                 },
  //                 {
  //                   id: 12001003004,
  //                   label: '修改项目',
  //                   pid: 12001003,
  //                 },
  //               ]
  //             },
  //             {
  //               id: 12001004,
  //               label: '合同登记',
  //               icon: 'mdi-eslint ',
  //               path: '/Contract',
  //               pid: 12001,
  //               children: [{
  //                   id: 12001004004,
  //                   label: '合同导入',
  //                   pid: 12001004,
  //                 },
  //                 {
  //                   id: 12001004005,
  //                   label: '合同导出',
  //                   pid: 12001004,
  //                 },
  //                 {
  //                   id: 12001004001,
  //                   label: '合同创建',
  //                   pid: 12001004,
  //                 },
  //                 {
  //                   id: 12001004002,
  //                   label: '合同编辑',
  //                   pid: 12001004,
  //                 },
  //                 {
  //                   id: 12001004003,
  //                   label: '合同续签',
  //                   pid: 12001004,
  //                 },
  //                 {
  //                   id: 12001004006,
  //                   label: '合同总价设置',
  //                   pid: 12001004,
  //                 },
  //                 {
  //                   id: 12001004007,
  //                   label: '合同起始设置',
  //                   pid: 12001004,
  //                 },
  //                 {
  //                   id: 12001004008,
  //                   label: '款项周期设置',
  //                   pid: 12001004,
  //                 },
  //                 {
  //                   id: 12001004009,
  //                   label: '月金额设置',
  //                   pid: 12001004,
  //                 },
  //                 {
  //                   id: 12001004010,
  //                   label: '合同停止设置',
  //                   pid: 12001004,
  //                 },

  //               ]
  //             },
  //           ]
  //         },
  //         {
  //           id: 12002,
  //           label: '财务管理',
  //           icon: 'mdi-eslint ',
  //           path: '/Contract/ContractFinance',
  //           pid: 12,
  //           is_menu: true,
  //           children: [{
  //               id: 12002001,
  //               label: '变动登记',
  //               icon: 'mdi-eslint ',
  //               path: '/Contract/ContractFinance',
  //               pid: 12002,
  //               children: [{
  //                   id: 12002001001,
  //                   label: '审核权限',
  //                   pid: 12002001,
  //                 },
  //                 {
  //                   id: 12002001002,
  //                   label: '变动登记',
  //                   pid: 12002001,
  //                 },
  //               ]
  //             },
  //             {
  //               id: 12002002,
  //               label: '开票登记',
  //               icon: 'mdi-eslint ',
  //               path: '/Contract/ContractFinanceInvoice',
  //               pid: 12002,
  //               children: [{
  //                   id: 12002002001,
  //                   label: '审核权限',
  //                   pid: 12002002,
  //                 },
  //                 {
  //                   id: 12002002002,
  //                   label: '开票登记',
  //                   pid: 12002002,
  //                 },
  //                 {
  //                   id: 12002002003,
  //                   label: '开票撤销',
  //                   pid: 12002002,
  //                 },
  //               ]
  //             },
  //             {
  //               id: 12002003,
  //               label: '收款登记',
  //               icon: 'mdi-eslint ',
  //               path: '/Contract/ContractFinanceIncome',
  //               pid: 12002,
  //               children: [{
  //                   id: 12002003001,
  //                   label: '审核权限',
  //                   pid: 12002003,
  //                 },
  //                 {
  //                   id: 12002003002,
  //                   label: '收款登记',
  //                   pid: 12002003,
  //                 },
  //               ]
  //             },
  //             {
  //               id: 12002004,
  //               label: '收款记录',
  //               icon: 'mdi-eslint ',
  //               path: '/Contract/ContractFinanceArrears',
  //               pid: 12002,
  //               children: [{
  //                   id: 12002004001,
  //                   label: '普通红冲',
  //                   pid: 12002004,
  //                 },
  //                 {
  //                   id: 12002004002,
  //                   label: '审核红冲',
  //                   pid: 12002004,
  //                 },
  //               ]
  //             },
  //           ]
  //         },
  //         {
  //           id: 12003,
  //           label: '报表管理',
  //           icon: 'mdi-eslint ',
  //           path: '/Contract/Receivables',
  //           pid: 12,
  //           is_menu: true,
  //           children: [{
  //               id: 12003001,
  //               label: '应收款台账',
  //               icon: 'mdi-eslint ',
  //               path: '/Contract/Receivables2',
  //               pid: 12003,
  //               children: [

  //               ]
  //             },
  //             {
  //               id: 12003002,
  //               label: '已收款台账',
  //               icon: 'mdi-eslint ',
  //               path: '/Contract/ReceivedAccount',
  //               pid: 12003,
  //               children: [

  //               ]
  //             },
  //             {
  //               id: 12003004,
  //               label: '开票末回款',
  //               icon: 'mdi-eslint ',
  //               path: '/Contract/InvoiceUncollected',
  //               pid: 12003,
  //               children: [

  //               ]
  //             },
  //             {
  //               id: 12003003,
  //               label: '欠费账龄表',
  //               icon: 'mdi-eslint ',
  //               path: '/Contract/ArrearageAging',
  //               pid: 12003,
  //               children: [

  //               ]
  //             },
  //           ]
  //         },
  //       ],
  //     },
  //     {
  //       id: 11006,
  //       label: '员工管理',
  //       icon: 'mdi-eslint ',
  //       path: '/Oa/PreUserManage',
  //       pid: 23,
  //       children: [{
  //         id: 11006001,
  //         label: '人员管理',
  //         icon: 'mdi-home-outline ',
  //         path: '/Oa/PreUserManage',
  //         pid: 11006,
  //         is_menu: true
  //       }, {
  //         id: 11006002,
  //         label: '职位管理',
  //         icon: 'mdi-home-outline ',
  //         path: '/Oa/PreJobManage',
  //         pid: 11006,
  //         is_menu: true
  //       }, {
  //         id: 11006003,
  //         label: '考勤列表',
  //         icon: 'mdi-home-outline ',
  //         path: '/Oa/AttendanceList',
  //         pid: 11006,
  //         is_menu: true
  //       }, {
  //         id: 11006004,
  //         label: '权限管理',
  //         icon: 'mdi-home-outline ',
  //         path: '/Oa/RoleList',
  //         pid: 11006,
  //         is_menu: true
  //       }, {
  //         id: 11006005,
  //         label: '流程配置',
  //         icon: 'mdi-home-outline ',
  //         path: '/Oa/FlowConfingList',
  //         pid: 11006,
  //         is_menu: true
  //       }, {
  //         id: 11006007,
  //         label: '出勤和加班管理',
  //         icon: 'mdi-home-outline ',
  //         path: '/Oa/SchedulingList',
  //         pid: 11006,
  //         is_menu: true
  //       }, {
  //         id: 11006008,
  //         label: '项目基本配置',
  //         icon: 'mdi-home-outline ',
  //         path: '/Oa/ProjectConfigList',
  //         pid: 11006,
  //         is_menu: true
  //       }]
  //     },
  //   ],
  //   is_menu: true,
  // },
  {
    id: 24,
    label: '运营管理',
    icon: 'mdi-home-outline ',
    path: '/',
    pid: 0,
    is_menu: true,
  },
  {
    id: 25,
    label: '基础管理',
    icon: 'mdi-home-outline ',
    path: '/',
    pid: 0,
    is_menu: true,
  },
  {
    id: 10,
    label: '设置',
    icon: 'mdi-eslint ',
    path: '/Config/Config', // /mb
    pid: 0,
    children: [{
        id: 10001,
        label: '基础设置',
        icon: 'mdi-eslint',
        path: '/Config/Config', // /mb
        pid: 10,
      },
      {
        id: 2,
        label: '项目',
        icon: 'mdi-archive-outline ',
        path: '/pindex/index',
        pid: 10,
        children: [{
            id: 2001,
            label: '项目列表',
            path: '/pindex/index',
            pid: 2,
            children: [{
                id: 2001001,
                label: '添加项目',
                pid: 2001,
              },
              {
                  id: 20010017,
                  label: '账龄费项设置',
                  pid: 2001,
              },
              {
                id: 2001002,
                label: '查看',
                pid: 2001,
              },
              {
                id: 2001003,
                label: '抄表导入水电费',
                pid: 2001,
              },
              {
                id: 2001004,
                label: '抄表导入水电费-设置费用',
                pid: 2001,
              },
              {
                id: 2001005,
                label: '抄表导入水电费-导入水电费',
                pid: 2001,
              },
              {
                id: 2001006,
                label: '抄表导入水电费-模板下载',
                pid: 2001,
              },
              {
                id: 2001017,
                label: '抄表导入水电费-生成订单',
                pid: 2001,
              },
              {
                id: 2001007,
                label: '抄表导入水电费-下载',
                pid: 2001,
              },
              {
                id: 2001008,
                label: '抄表导入水电费-删除',
                pid: 2001,
              },
              {
                id: 2001009,
                label: '绑定收费项生成订单',
                pid: 2001,
              },
              {
                id: 2001010,
                label: '绑定收费项生成订单-绑定收费项',
                pid: 2001,
              },
              {
                id: 2001011,
                label: '绑定收费项生成订单-生成订单',
                pid: 2001,
              },
              {
                id: 2001012,
                label: '绑定收费项生成订单-修改绑定收费项',
                pid: 2001,
              },
              {
                id: 2001013,
                label: '绑定收费项生成订单-删除',
                pid: 2001,
              },
              {
                id: 2001014,
                label: '修改项目',
                pid: 2001,
              },
              {
                id: 2001015,
                label: '删除项目',
                pid: 2001,
              },
              {
                id: 2001016,
                label: '费项设置',
                pid: 2001,
              },
            ]
          },
          {
            id: 3002005,
            label: '项目管理',
            icon: 'mdi-archive-outline ',
            path: '/pindex/zone',
            pid: 2,
          },
          // {
          //   id: 2003,
          //   label: '新视窗导入',
          //   path: '/pindex/xsc/xsc',
          //   pid: 2,
          //   is_menu: true,
          // },
          // {
          //   id: 2004,
          //   label: '应收对账',
          //   path: '/pindex/xsc/receivable',
          //   pid: 2,
          //   is_menu: true,
          // },
          // {
          //   id: 2005,
          //   label: '欠费对账',
          //   path: '/pindex/xsc/arrearage',
          //   pid: 2,
          //   is_menu: true,
          // },
          // {
          //   id: 2006,
          //   label: '收费对账',
          //   path: '/pindex/xsc/charge',
          //   pid: 2,
          //   is_menu: true,
          // },
          // {
          //   id: 2007,
          //   label: '同步修改',
          //   path: '/pindex/xsc/with',
          //   pid: 2,
          //   is_menu: true,
          // },
          {
            id: 2008,
            label: '项目分类',
            path: '/pindex/belong',
            pid: 2,
            is_menu: true,
          }
        ]
      },
      {
        id: 7006,
        label: '菜单管理',
        path: '/Jindex/MenuTree',
        pid: 10,
        is_menu: true,
      },
      {
        id: 10002,
        label: '生成目录',
        icon: 'mdi-eslint ',
        path: '/Config/CreateTreeMenu', //
        pid: 10,
      },
      {
        id: 10006,
        label: '运维管理',
        icon: 'mdi-eslint',
        path: '/Log/LogList', // /mb
        pid: 10,
        children: [{
            id: 10006001,
            label: '前端日志',
            icon: 'mdi-eslint',
            path: '/Log/LogList', // /mb
            pid: 10006,
            is_menu: true,
          },
          {
            id: 10006002,
            label: '抽检配置',
            icon: 'mdi-eslint',
            path: '/Butler/TaskUserConfig', // /mb
            pid: 10006,
            is_menu: true,
          },
        ]
      },
      {
        id: 6002,
        label: '操作日记',
        path: '/operation/log',
        pid: 10,
        is_menu: true,
        children: [{
          id: 6002001,
          label: '添加组织',
          pid: 6002,
        }, ]
      },
      {
        id: 9001,
        label: '小程序管理',
        path: '/Applets/appletslist',
        pid: 10,
        is_menu: true,
      },
      {
        id: 9002,
        label: '首页装修',
        path: '/Applets/appletsHome',
        pid: 10,
        is_menu: true,
      },
      {
        id: 9003,
        label: '支付配置',
        path: '/Applets/appletsclass',
        pid: 10,
        is_menu: true,
      },
      {
        id: 9004,
        label: 'CMS',
        path: '/Cms/',
        pid: 10,
        children: [{
            id: 9004001,
            label: '栏目列表',
            path: '/Cms/CmsChannel',
            pid: 9004,
            children: [

            ],
          },
          {
            id: 9004002,
            label: '内容列表',
            path: '/Cms/CmsArticle',
            pid: 9004,
            children: [

            ],
          },
        ],
      },
      // {
      //   id: 11005,
      //   label: '考勤管理',
      //   icon: 'mdi-eslint ',
      //   path: '/Oa/Attendance/list',
      //   pid: 23,
      //   children: [{
      //     id: 11005001,
      //     label: '考勤设置',
      //     icon: 'mdi-home-outline ',
      //     path: '/Oa/Attendance/set',
      //     pid: 11005,
      //     is_menu: true
      //   },{
      //     id: 11005002,
      //     label: '考勤列表',
      //     icon: 'mdi-home-outline ',
      //     path: '/Oa/AttendanceList',
      //     pid: 11005,
      //     is_menu: true
      //   }]
      // },
      {
        id: 9005,
        label: '人事管理',
        path: '/hr-setup/',
        pid: 10,
        children: [{
            id: 9005001,
            label: '公司管理',
            path: '/hr-setup/company',
            pid: 9005,
            children: [{
              id: 9005101,
              label: '公司设置',
              path: '/hr-setup/company-edit',
              pid: 9005001,
              children: [

              ],
            }, ],
          },
          {
            id: 9005002,
            label: '部门管理',
            path: '/hr-setup/department',
            pid: 9005,
            children: [{
              id: 9005201,
              label: '部门设置',
              path: '/hr-setup/department-edit',
              pid: 9005002,
              children: [

              ],
            }, ],
          },
          {
            id: 9005003,
            label: '部门定编',
            path: '/hr-setup/business',
            pid: 9005,
            children: [{
                id: 9005301,
                label: '批量定编人数查询',
                path: '/hr-setup/business-all',
                pid: 9005003,
                children: [

                ],
              },
              {
                id: 9005303,
                label: '批量定编人数设置',
                path: '/hr-setup/business-edit',
                pid: 9005003,
                children: [

                ],
              },
              {
                id: 9005304,
                label: '批量定编人数导入',
                path: '/hr-setup/business-import',
                pid: 9005003,
                children: [

                ],
              },
            ],
          },
          {
            id: 9005004,
            label: '部门设置',
            path: '/hr-setup/department-setting',
            pid: 9005,
            children: [{
              id: 9005004001,
              label: '部门设置',
              path: '/hr-setup/department-setting',
              pid: 9005004,
              children: [

              ],
            }, ],
          },
          {
            id: 9005005,
            label: '部门编辑',
            path: '/hr-setup/department-setting-detail',
            pid: 9005,
            children: [{
              id: 9005005001,
              label: '部门编辑',
              path: '/hr-setup/department-setting-detail',
              pid: 9005004,
              children: [

              ],
            }, ],
          },
        ],
      },
      {
        id: 9006,
        label: '集团服务',
        path: '/',
        pid: 10,
        children: [{
            id: 9006001,
            label: '集团服务',
            path: '/study/red-envelopes',
            pid: 9006,
            children: [

            ],
          },
          {
            id: 9006002,
            label: '发放红包',
            path: 'https://flow.gdzawy.com:9001/readback/zhongao.html',
            pid: 9006,
            children: [],
          },
        ],
      },
    ],
  },

  // 合同管理
  {
    id: 14,
    label: '合同管理',
    icon: 'mdi-eslint ',
    path: '/',
    pid: 0,
    children: [{
      id: 14001,
      label: '设置管理',
      icon: 'mdi-eslint ',
      path: '/contract/cust-list',
      pid: 14,
      children: [{
          id: 14001001,
          label: '客户列表',
          icon: 'mdi-eslint ',
          path: '/contract/cust-list',
          pid: 14001,
          is_menu: true
        },
        {
          id: 14001002,
          label: '分类列表',
          icon: 'mdi-eslint ',
          path: '/contract/cate-list',
          pid: 14001,
          is_menu: true
        },
        {
          id: 14001003,
          label: '业户类型列表',
          icon: 'mdi-eslint ',
          path: '/contract/business-list',
          pid: 14001,
          is_menu: true
        },
        {
          id: 14001004,
          label: '字典列表',
          icon: 'mdi-eslint ',
          path: '/contract/field-list',
          pid: 14001,
          is_menu: true
        },
        {
          id: 14001005,
          label: '模板列表',
          icon: 'mdi-eslint ',
          path: '/contract/template-list',
          pid: 14001,
          is_menu: true
        },
      ]
    },{
      id: 14002,
      label: '合同管理',
      icon: 'mdi-eslint ',
      path: '/contract/contract-list',
      pid: 14,
      children: [{
          id: 14002001,
          label: '合同列表',
          icon: 'mdi-eslint ',
          path: '/contract/contract-list',
          pid: 14002,
          is_menu: true
        },
      ]
    }]
  },
  // {
  //   id: 15,
  //   label: '财务图表',
  //   icon: 'mdi-eslint',
  //   path: '/financialChart/index',
  //   pid: 0,
  //   children: [
  //     {
  //       id: 15001,
  //       label: '财务图表',
  //       path: '/financialCharts/index',
  //       pid: 14,
  //     }
  //   ]
  // }
];
export default data;



// WEBPACK FOOTER //
// ./src/assets/js/tree.js